import { add } from 'lodash'
import allPaths from '../Config/paths'

const bgColor = '#0adc00'
const dateFormate = 'DD/MM/YYYY'
const tableDateFormate = 'YYYYMMDD'
const version = '1.0.24'
const deployDate = '17/09/2026'

const containerStyle = {
    width: '100%',
    height: '430px',
}

const center = {
    lat: 31.5204,
    lng: 74.3587,
}

const translations = {
    it: {

        panel: 'Pannello',
        panelList: "Elenco dei pannelli",
        ledPanel: "Pannello LED",

        code: "Codice",
        codePlaceholder: "Seleziona numero di serie",

        brand: "Marca",
        brandPlaceholder: "Seleziona marca",

        panelFront: "Frontale",
        panelSide: "Laterale",
        panelRear: "Posteriore",

        panelModel: "Modello del pannello",
        panelModelPlaceholder: "Inserisci il modello del pannello",

        text: "Testo",
        textPlaceholder: "Inserisci testo",

        effect: "Effetto",
        effectStatic: "Statico",
        effectScroll: "Scorrimento",
        effectBlink: "Lampeggiante",
        speed: "Velocità",
        speedPlaceholder: "Inserisci velocità",

        brightness: "Luminosità",
        brightnessPlaceholder: "Inserisci luminosità",

        color: "Colore",

        preview: "Anteprima",
        save: "Salva",

        posSerialNumber: "Numero di serie del POS",
        passengerCounterPositioning: "Posizionamento (anteriore, posteriore, centrale)",
        totalRecord: 'Record Totali',
        enterMacAddress: 'Inserisci l\'indirizzo MAC',
        createdAt: 'Creato il',
        refreshButton: 'Aggiorna',
        status: 'Stato',
        regNumber: 'Matricola',
        teltonikaInstructionDescription: 'Una guida completa per configurare il tuo router Teltonika per l’inoltro dei dati GPS utilizzando il protocollo NMEA. Questa integrazione consente il tracciamento e il monitoraggio della posizione in tempo reale con una configurazione minima.',
        teltonikaInstructionHeading: 'Istruzioni Teltonika',
        teltonikaInstructionDescription: 'Una guida completa per configurare il tuo router Teltonika per l’inoltro dei dati GPS utilizzando il protocollo NMEA. Questa integrazione consente il tracciamento e il monitoraggio della posizione in tempo reale con una configurazione minima.',
        overviewHeading: 'Panoramica',
        overviewText: 'Per integrare il tuo router Teltonika con la nostra piattaforma, i dati GPS devono essere inoltrati tramite il servizio NMEA Forwarding. È necessario configurare il router per inviare questi dati all\'indirizzo IP e alla porta forniti utilizzando il protocollo e il prefisso specificati.',
        prerequisitesHeading: 'Prerequisiti',
        prerequisitesText: 'Prima di procedere con la configurazione, assicurati di avere accesso amministrativo al tuo router Teltonika e verifica i seguenti dettagli della connessione al server:',
        serverAddress: 'Indirizzo Server',
        port: 'Porta',
        protocol: 'Protocollo',
        prefix: 'Prefisso',
        additionalConfirmText: 'Inoltre, conferma che:',
        additionalConfirmList1: 'La connettività di rete al server di destinazione è disponibile',
        additionalConfirmList2: 'Il firmware del router supporta le funzionalità di inoltro NMEA',

        configurationHeading: 'Configurazione',
        accessRouterInterface: 'Accesso all’interfaccia del router',
        accessRouterInterfaceText: 'Apri il browser web e vai al pannello di amministrazione del router. L’indirizzo predefinito è solitamente 192.168.1.1. Inserisci le credenziali di amministratore quando richiesto.',

        navigateToSettings: 'Naviga nelle impostazioni NMEA',
        navigateToSettingsText: 'Una volta effettuato l’accesso, trova la sezione di configurazione GPS seguendo questo percorso:',
        navServices: 'Servizi',
        navGPS: 'GPS',
        navNMEA: 'NMEA',
        navForwarding: 'Inoltro NMEA',

        enableForwarding: 'Abilita e configura l’inoltro',
        enableForwardingText1: 'Nella sezione NMEA Forwarding, abilita la funzione di inoltro e aggiungi una nuova configurazione host con i dettagli del server forniti sopra.',
        enableForwardingText2: 'Fai clic sull\'icona ➕ per aggiungere un nuovo host.',
        enableForwardingText3: 'La configurazione dovrebbe apparire simile a questa:',
        containConnection: 'Connessione Contenuta',
        containConnectionValue: 'DISATTIVATO',
        hostName: 'Nome Host',

        saveAndVerify: 'Salva e verifica',
        saveAndVerifyText: 'Applica le modifiche alla configurazione e monitora lo stato della connessione. L’interfaccia dovrebbe indicare una connessione riuscita al server remoto. La trasmissione dei dati GPS inizierà automaticamente una volta stabilita la connessione.',

        exampleUIReference: 'Esempio di interfaccia utente',

        importantNotesHeading: 'Note Importanti',
        protocolSelectionNote: 'TCP è consigliato rispetto a UDP per l’inoltro NMEA in quanto garantisce un’invio dati affidabile e mantiene l’integrità della connessione, particolarmente importante per le applicazioni di tracciamento GPS continuo.',
        firewallConsiderationsNote: 'Verifica che il firewall di rete e le impostazioni di sicurezza del router consentano le connessioni in uscita all’indirizzo e alla porta del server specificati. Alcune reti aziendali potrebbero richiedere configurazioni aggiuntive.',
        multipleDestinationsNote: 'Il router supporta l’inoltro dei dati GPS a più endpoint host contemporaneamente. È sufficiente aggiungere ulteriori configurazioni host se desideri inviare i dati a server di backup o a diversi sistemi di monitoraggio.',
        teltonikaInstruction: 'Istruzioni Teltonika',
        teltonikaInstructionHeading: 'Istruzioni per l’integrazione di Teltonika',
        dateTxtReport: "Data",
        txtRemainingPassengers: "a bordo",
        txtExitPassengers: "Uscita",
        txtEnterPassengers: "Entrare",
        txtTotalPassengers: "Totale",
        totalPassengers: "Totale Passeggeri",
        totalEnter: "Totale Entrate",
        totalExit: "Totale Uscite",
        remainingPassengers: "Passeggeri Rimanenti",
        qrCodeScannerTitle: 'Scanner di codici QR',
        scanQr: 'Scansiona QR',
        logout: 'Esci',
        signIn: 'Accedi',
        search: 'Cerca',
        dashboard: 'Dashboard',
        menuGroupOverview: 'Panoramica',
        menuGroupFleet: 'Flotta',
        menuGroupAnalytics: 'Analisi',
        menuGroupParking: 'Parcheggi',
        menuGroupAdmin: 'Amministrazione',
        menuGroupSystem: 'Sistema',
        vehicles: 'Veicoli',
        gtfs: 'GTFS',
        gtfsName: 'Nome GTFS',
        editGtfsName: 'Modifica Nome GTFS',
        gtfsList: 'Lista GTFS',
        gtfsDetails: 'Dettagli GTFS',
        addGtfs: 'Aggiungi GTFS',
        routes: 'Linee',
        stops: 'Fermate',
        attachedVehicles: 'Veicoli Collegati',
        attachVehicle: 'Collega Veicolo',
        attachOrgHint: 'Vengono elencati solo i veicoli di questa organizzazione, a cui appartiene il GTFS.',
        searchRoute: 'Cerca linea o percorso',
        selectVehiclePlaceholder: 'Seleziona i veicoli (nome, targa o matricola)',
        detachVehicle: 'Scollega Veicolo',
        changeLineTrip: 'Cambia linea / corsa',
        currentLine: 'Linea attuale',
        newLine: 'Nuova linea',
        newTrip: 'Nuova corsa',
        optionalWholeLine: 'opzionale: vuoto = assegna solo la linea',
        selectLine: 'Seleziona una linea',
        selectTrip: 'Seleziona una corsa',
        shift: 'Turno',
        inUseBy: 'in uso da',
        forceReassign: 'Sovrascrivi anche se la corsa è già assegnata a un altro veicolo',
        reasonOptional: 'Motivo (opzionale)',
        reassignNote: 'La modifica è immediata: il pannello percorso e i display pubblici (Route Forecast) la mostrano entro 30 secondi. L\'assegnazione manuale resta bloccata fino a fine giornata di servizio; lo storico viene conservato.',
        applyChange: 'Applica',
        confirmLineChange: 'Conferma cambio linea',
        confirmLineChangeText: 'Questa modifica aggiorna i dati pubblici in tempo reale. Spostare',
        toLine: 'sulla linea',
        lineChanged: 'Linea aggiornata',
        lineChangeFailed: 'Cambio linea non riuscito',
        manualAssignment: 'Assegnazione manuale',
        lockedUntil: 'bloccata fino a',
        noActiveTrips: 'Nessuna corsa attiva oggi per questa linea',
        assignmentHistory: 'Storico assegnazioni',
        noAssignmentHistory: 'Nessun cambio registrato',
        wholeLine: 'intera linea',
        forced: 'forzato',
        moveToGtfs: 'Sposta in altro GTFS',
        selectVehicle: 'Seleziona veicolo',
        selectGtfsFeed: 'Seleziona GTFS',
        vehicleAttached: 'Veicolo collegato al GTFS',
        vehicleMoved: 'Veicolo spostato nel nuovo GTFS',
        vehicleDetached: 'Veicolo scollegato dal GTFS',
        noVehiclesToAttach: 'Nessun veicolo disponibile da collegare',
        attachedToOtherGtfs: 'collegato a',
        attachLockedHint: 'I veicoli già collegati a un altro GTFS vanno prima scollegati da lì.',
        areYouSureDetachVehicle: 'Sei sicuro di voler scollegare questo veicolo dal GTFS?',
        lineDetected: 'linea rilevata',
        lineSuggested: 'linea suggerita dalla cronologia GPS',
        linePendingNotMoving: 'veicolo fermo — la linea verrà rilevata alla partenza',
        lineStatus: 'Stato linea',
        confirmed: 'Confermata',
        unconfirmed: 'Non confermata',
        shifts: 'Turni',
        shift: 'Turno',
        liveNow: 'In viaggio ora',
        noShifts: 'Nessun turno trovato per questa linea',
        noShiftAssigned: 'Senza turno',
        vehicle: 'Veicolo',
        routeHistory: 'Cronologia Percorsi',
        routeHistorySubtitle: 'Corse giornaliere di tutti i veicoli: chilometri, velocità e aderenza al programma.',
        routesToday: 'Corse di oggi',
        totalTrips: 'Corse totali',
        vehiclesWithTrips: 'Veicoli in servizio',
        vehiclesWithRouter: 'veicoli con router',
        onSchedule: 'In orario',
        offSchedule: 'Fuori programma',
        avgAdherence: 'Aderenza media',
        tripsPerLine: 'Corse per linea',
        lineVehicles: 'Veicoli sulla linea',
        vehiclesShort: 'veicoli',
        attachedToLine: 'collegati alla linea',
        ranTodayOnly: 'ha percorso la linea oggi',
        tripsToday: 'corse oggi',
        lastRunAt: 'ultima corsa',
        noVehiclesOnLine: 'Nessun veicolo collegato o in servizio su questa linea oggi',
        searchVehicle: 'Cerca veicolo, targa o linea',
        allStatuses: 'Tutti gli stati',
        allOrganizations: 'Tutte le organizzazioni',
        onlyVehiclesWithTrips: 'Solo veicoli con corse',
        noTripsForDay: 'Nessuna corsa registrata per questa data',
        noTripsHint: 'Seleziona un altro giorno o verifica che i veicoli abbiano un router attivo.',
        noTripsForVehicle: 'Nessuna corsa per questo veicolo',
        mapMatchingInProgress: 'Elaborazione tracce in corso…',
        viewRouteHistory: 'Vedi cronologia percorsi',
        statusBreakdown: 'Stato delle corse',
        passengersTxt: 'Passeggeri',
        perTrip: 'per corsa',
        retryTxt: 'Riprova',
        routeStatsLoadFailed: 'Impossibile caricare le corse di oggi',
        routeStatsLoadFailedHint: 'Il server sta ancora elaborando i dati della flotta. Riprova tra qualche secondo.',
        showAllTrips: 'Mostra tutte le corse',
        showFewerTrips: 'Mostra meno',
        more: 'altre',
        kmTraveled: 'KM Percorsi',
        scheduledDistance: 'Distanza Prevista',
        avgSpeed: 'Velocità Media',
        maxSpeed: 'Velocità Max',
        adherence: 'Aderenza',
        normal: 'Normale',
        abnormal: 'Anormale',
        noSchedule: 'Nessuna corsa pianificata',
        noRoutesFound: 'Nessun percorso trovato per questa data',
        uploaded: 'Caricato',
        searchGtfs: 'Cerca GTFS...',
        noGtfsFound: 'Nessun GTFS trovato',
        addGtfsToSee: 'Carica un pacchetto GTFS per vederlo qui',
        direction: 'Direzione',
        duration: 'Durata',
        trips: 'Corse',
        firstDeparture: 'Prima Partenza',
        lastArrival: 'Ultimo Arrivo',
        mapView: 'Vista mappa',
        stopsView: 'Elenco fermate',
        startStop: 'Partenza',
        endStop: 'Arrivo',
        noLineGeometry: 'Nessuna geometria disponibile per questa linea',
        noStopCoordinates: 'Le fermate di questa linea non hanno ancora coordinate reali (segnaposto dalla conversione Excel).',
        stopCoordinates: 'Coordinate fermate',
        stopCoordinatesIntro: 'Le fermate importate da Excel senza coordinate vengono posizionate su un segnaposto. Qui ricevono le coordinate reali: vengono cercate tra le fermate già presenti in piattaforma per la zona di Chieti e, se lo carichi, in un file fermate (CSV o GTFS zip), abbinate per codice e poi per nome.',
        stopCoordinatesFiles: 'File fermate (opzionale)',
        stopsFileHint: 'CSV con stop_id, stop_code, stop_name, stop_lat, stop_lon (o un GTFS zip). Abbinato per codice e poi per nome; ha la precedenza sulla ricerca automatica.',
        selectStopsFile: 'Trascina qui un file o clicca per sceglierlo',
        resolveCoordinates: 'Assegna coordinate',
        coordsResolvedNow: 'fermate risolte',
        coordsStillMissing: 'ancora senza coordinate',
        coordsPlaceholders: 'fermate segnaposto',
        coordsReferencePlatform: 'fermate di riferimento in piattaforma',
        coordsReferenceFiles: 'fermate di riferimento da file',
        coordsNoReference: 'Nessuna fermata di riferimento trovata per la zona di Chieti: carica un file fermate con le coordinate (CSV o GTFS zip) e riprova.',
        coordsNothingToDo: 'Tutte le fermate hanno già coordinate reali.',
        coordsDone: 'Coordinate fermate aggiornate',
        coordsFailed: 'Impossibile assegnare le coordinate',
        tryAgain: 'Riprova',
        geocodeRest: 'Trova da sola le fermate che restano',
        geocodeRestHint: 'Il nome della fermata viene cercato nella zona di Chieti (punto di riferimento tra parentesi, altrimenti la via) e agganciato alla strada più vicina tramite il server mappe. Circa una fermata al secondo: la finestra continua da sola fino alla fine.',
        coordsGeocoded: 'trovate dal nome',
        coordsGeocodeCached: 'già note (senza nuove richieste)',
        coordsGeocodeMissing: 'Le fermate rimaste non sono state trovate nemmeno dal nome. Premi Riprova per cercarle di nuovo (anche con un file fermate, se ce l\'hai): le altre sono già salvate.',
        coordsRetryNote: 'fermate ancora senza coordinate: verranno cercate di nuovo, comprese quelle già tentate. Se hai un file fermate con le coordinate, caricalo qui sopra prima di avviare.',
        detectLines: 'Rileva linee',
        detectLinesIntro: 'Per ogni veicolo collegato, la traiettoria GPS degli ultimi giorni viene confrontata con le fermate di ogni linea: la linea di cui il veicolo ha toccato più fermate è la candidata. Controlla la proposta, correggila se serve e conferma. Una linea assegnata da qui resta "non confermata" finché il match dal vivo non la conferma.',
        runDetection: 'Avvia rilevamento',
        detectionRunning: 'Analisi della cronologia GPS in corso…',
        detectedLine: 'Linea rilevata',
        coverage: 'Copertura',
        runnerUp: 'Seconda',
        assignLine: 'Assegna linea',
        assignSelected: 'Assegna selezionate',
        keepCurrent: 'Attuale',
        noChange: 'Nessuna modifica',
        clearLine: 'Nessuna linea',
        historyDays: 'giorni di cronologia',
        stopsCovered: 'fermate toccate',
        detectReason: {
          no_router: 'nessun router GPS collegato',
          no_history: 'nessuna posizione GPS negli ultimi giorni',
          no_stops: 'la linea non ha fermate con coordinate',
          ambiguous: 'copertura troppo bassa o ambigua tra più linee',
          detection_error: 'rilevamento non riuscito',
        },
        linesAssigned: 'Linee assegnate',
        assignFailed: 'Impossibile assegnare le linee',
        nothingSelected: 'Seleziona almeno un veicolo',
        geocodeProgress: 'Ricerca in corso, fermate rimanenti:',
        backToGtfs: 'Torna a GTFS',
        stopsOfLine: 'Fermate della linea',
        deleteGtfs: 'Elimina GTFS',
        replaceGtfs: 'Sostituisci GTFS',
        versions: 'Versioni',
        previousVersion: 'Versione precedente',
        currentVersion: 'Versione attuale',
        replacedOn: 'Sostituita il',
        activeSince: 'Attiva dal',
        areYouSureYouWantToDltThisGtfs: 'Sei sicuro di voler eliminare questo GTFS?',
        route: 'Percorso',
        trip: 'Corsa',
        lastSeen: 'Ultima rilevazione',
        fleetStatus: 'Stato della flotta',
        activeVehicles: 'Veicoli attivi',
        onlineDevices: 'Dispositivi online',
        gtfsFeeds: 'Feed GTFS',
        online: 'Online',
        offline: 'Offline',
        inactive: 'Inattivo',
        vehiclesPerLine: 'Veicoli per linea',
        welcomeBack: 'Bentornato',
        liveFleetMap: 'Mappa live della flotta',
        live: 'Live',
        viewAll: 'Vedi tutto',
        thisMonth: 'questo mese',
        goodMorning: 'Buongiorno',
        goodAfternoon: 'Buon pomeriggio',
        goodEvening: 'Buonasera',
        onlineOnly: 'Solo online',
        total: 'Totale',
        devices: 'Dispositivi',
        users: 'Utenti',
        camera: 'Telecamere',
        statics: 'Statistiche',
        active: 'Attivo',
        vehicleName: 'Nome del veicolo',
        deviceName: 'Nome del dispositivo',
        progress: 'Progresso',
        details: 'Dettagli',
        licensePlate: 'Targa',
        companyAffiliation: 'Affiliazione aziendale',
        totalDevices: 'Dispositivi',
        vehicleCategory: 'Categoria del veicolo',
        vehicleModel: 'Modello del veicolo',
        yearOfManufacture: 'Anno di fabbricazione',
        operationStartDate: 'Data di inizio',
        action: 'Azione',
        addVehicle: 'Aggiungi veicolo',
        getReports: 'Ottieni rapporti',
        noVehiclesFound: 'Nessun veicolo trovato',
        addVehicleToSee: 'Aggiungi un veicolo per vederlo qui',
        vehiclesList: 'Lista dei veicoli',
        techMaintenanceNotes: 'Note tecniche o di manutenzione',
        vehicleDetails: 'Dettagli del veicolo',
        editVehicle: 'Modifica veicolo',
        updateVehicle: 'Aggiorna veicolo',
        notProvided: 'Non fornito',
        areYouSure: 'Sei sicuro?',
        delete: 'Eliminare',
        internalIdCode: 'Codice identificativo interno',
        enterInternalIdCode: 'Per favore inserisci il codice identificativo interno',
        deviceType: 'Tipo di dispositivo',
        brand: 'Marca',
        model: 'Modello',
        serialNumber: 'Numero di serie',
        macAddress: 'Indirizzo MAC',
        routerPassword: 'Password del router',
        routerName: 'Nome del router',
        vehicleAssociation: 'Associazione veicolo',
        installationDate: 'Data di installazione',
        addDevice: 'Aggiungi dispositivo',
        deleteDeviceError: 'Impossibile eliminare il dispositivo. Riprova.',
        addDeviceError: 'Impossibile aggiungere il dispositivo. Riprova.',
        updateDevice: 'Aggiorna dispositivo',
        deviceDetails: 'Dettagli del dispositivo',
        areYouSureDeleteDevice: 'Sei sicuro di voler eliminare questo dispositivo?',
        noDevicesFound: 'Nessun dispositivo trovato',
        addDeviceToSeeListed: 'Aggiungi un dispositivo per vederlo qui',
        uniqueIdentificationCode: 'Codice di identificazione unico',
        pleaseEnterUniqueIdentificationCode: 'Per favore inserisci il codice di identificazione unico',
        pleaseEnterTypeOfDevice: 'Per favore inserisci il tipo di dispositivo',
        companyOrPersonName: 'Nome dell\'azienda o della persona',
        pleaseEnterBrand: 'Per favore inserisci la marca',
        pleaseEnterModel: 'Per favore inserisci il modello',
        pleaseEnterVehicleAssociation: 'Seleziona il veicolo da associare',
        pleaseSelectVehicle: 'Seleziona il veicolo da associare',
        pleaseSelectInstallationDate: 'Per favore seleziona la data di installazione',
        pleaseEnterRouter: 'Per favore inserisci il nome del router',
        pleaseEnterRouterPassword: 'Per favore inserisci la password del router',
        pleaseEnterMacAddress: 'Per favore inserisci l\'indirizzo MAC',
        pleaseEnterSerialNumber: 'Per favore inserisci il numero di serie',
        typeOfDevice: 'Tipo di dispositivo',
        immediateAssociationToVehicle: 'Veicolo associato',
        updateDevice: 'Aggiorna dispositivo',
        editDevice: 'Modifica dispositivo',
        placeholder: {
            uniqueIdentificationCode: 'Inserisci il codice di identificazione unico',
            typeOfDevice: 'Inserisci il tipo di dispositivo',
            model: 'Inserisci il modello',
            brand: 'Inserisci la marca',
            companyOrPersonName: 'Inserisci il nome dell\'azienda o della persona',
            immediateAssociationToVehicle: 'Seleziona il veicolo (nome, targa o matricola)',
            installationDate: 'Seleziona la data di installazione',
            routerName: 'Inserisci il nome del router',
            routerPassword: 'Inserisci la password del router',
            macAddress: 'Inserisci l\'indirizzo MAC',
            serialNumber: 'Inserisci il numero di serie'
        },
        profileInformation: 'Informazioni',
        company: 'Azienda',
        userName: 'Nome Utente',
        email: 'Indirizzo Email',
        phone: 'Telefono #',
        address: 'Indirizzo',
        addressLabel: 'Indirizzo',
        city: 'Città',
        postalCode: 'Codice Postale',
        country: 'Paese',
        usersHeading: 'Utenti',
        entervechicleName: 'Inserisci il nome del veicolo',
        enterVehicle: 'Inserisci veicolo',
        pleaseEntervechicleName: 'Per favore inserisci il nome del veicolo',
        vechicleName: 'Nome del veicolo',
        deviceName: 'Nome del dispositivo',
        devicePlaceholder: 'Inserisci il nome del dispositivo',
        pleaseEnterDevicePlaceholder: 'Per favore inserisci il nome del dispositivo',
        deviceAdded: 'Dispositivi aggiunti con successo',
        deleteheading: 'Elimina',
        deviceQuestion: 'Dispositivo',
        vechicleQuestion: 'Veicolo',
        association: 'Associazione',
        uniqueIdentificationCode: "Codice di Identificazione Unico",
        userNotFound: 'Nessun utente trovato',
        adduserToSeeItsList: 'Aggiungi un utente per vederlo elencato qui',
        addUserButton: 'Aggiungi utente',
        enterUserName: 'Inserisci nome',
        enterPassword: 'Inserisci password',
        enterEmailLabel: 'Email',
        enterEmail: 'Inserisci email',
        phoneNumber: 'Numero di telefono',
        enterPhoneNumber: 'Inserisci numero di telefono',
        roleSelect: 'Ruolo',
        cancelButton: 'Annulla',
        userNameList: 'Elenco utenti',
        seePassword: 'Cambia Password',
        selectRoleMessage: 'Seleziona un ruolo!',
        roleSelectType: 'Seleziona tipo di ruolo',
        accessAllow: 'Accesso consentito',
        userText: 'Utente',
        editUserText: 'Modifica utente',
        updateUserButton: 'Aggiorna utente',
        pleaseEnterName: 'Per favore, inserisci il tuo nome!',
        pleaseEnterPasword: 'Per favore, inserisci la tua password!',
        pleaseEnterEmail: 'Per favore, inserisci la tua email!',
        pleaseEnterPhone: 'Per favore, inserisci il tuo numero di telefono!',
        paswordtxt: 'Password',
        userDetailsHeading: 'Dettagli utente',
        nameTxt: 'Nome',
        reportsHeading: 'Report',
        filterheading: 'Filtro',
        startDate: 'Data di inizio',
        endDate: 'Data di fine',
        vechiclelabel: 'Veicolo',
        linesLabel: 'Linee',
        clearText: 'Cancella',
        applyTxt: 'Applica',
        datetxt: 'Time',
        activeVechicleL: 'Veicoli attivi',
        fueltxt: 'Carburante',
        devicesTabletxt: 'Dispositivi',
        profitloss: 'Profitto/Perdita',
        installDate: 'Data di installazione',
        getReport: 'Ottieni report',
        generateTxt: 'Genera',
        generateReport: 'Genera rapporto',
        uniqueIdentificationTxt: 'Codice identificativo univoco',
        typeOfDevice: 'Tipo di dispositivo',
        downloadButton: 'Scarica',
        settingHeading: 'Impostazioni',
        uploadVehicleHint: 'Carica un foglio Excel (.xlsx o .xls) con un veicolo per riga. Data di inizio e anno di fabbricazione si applicano a tutte le righe.',
        dropExcelHere: 'Trascina qui il file Excel oppure clicca per selezionarlo',
        excelOnly: 'Solo file .xlsx o .xls',
        replaceExcelHint: 'File selezionato. Trascina o clicca per sostituirlo',
        removeFile: 'Rimuovi',
        parkingSessions: 'Sessioni di parcheggio',
        showingRange: 'Mostrati {from}-{to} di {total}',
        viewDetails: 'Vedi dettagli',
        routerOnline: 'Router in linea',
        routerOffline: 'Router non in linea',
        updatedLabel: 'Aggiornato',
        peopleCounterSubtitle: 'Conteggi di ingressi e uscite rilevati dai contapasseggeri, per giorno e dispositivo.',
        peopleCounterRecordsTitle: 'Rilevazioni',
        reportsSubtitle: 'Conteggi passeggeri per veicolo e giorno nel periodo selezionato.',
        filtersLabel: 'Filtri',
        passengerReportsTitle: 'Report passeggeri',
        noReportData: 'Nessun dato per questi filtri',
        noReportDataHint: 'Modifica il periodo o i veicoli selezionati e applica di nuovo.',
        profileSettings: 'Impostazioni profilo',
        profileSubtitle: 'Gestisci le tue informazioni personali, la password e le preferenze.',
        preferences: 'Preferenze',
        personalInformation: 'Informazioni personali',
        personalInformationHint: 'Così appaiono il tuo nome e i tuoi contatti sulla piattaforma.',
        fullName: 'Nome completo',
        emailAddress: 'Indirizzo email',
        emailLocked: "L'email serve per l'accesso e non può essere modificata qui.",
        phoneNumber: 'Numero di telefono',
        organizationLabel: 'Organizzazione',
        roleLabel: 'Ruolo',
        memberSince: 'Membro dal',
        profilePhoto: 'Foto profilo',
        uploadPhoto: 'Carica foto',
        removePhoto: 'Rimuovi',
        photoHint: 'JPG, PNG o WebP, massimo 2 MB.',
        saveChanges: 'Salva modifiche',
        profileUpdated: 'Profilo aggiornato con successo',
        profileUpdateFailed: 'Impossibile completare la richiesta. Riprova.',
        invalidImage: "Scegli un'immagine JPG, PNG o WebP sotto i 2 MB",
        pleaseEnterName: 'Inserisci il tuo nome',
        invalidPhone: 'Inserisci un numero di telefono valido',
        changePassword: 'Cambia password',
        changePasswordHint: 'Usa almeno 8 caratteri, con lettere, numeri e simboli.',
        currentPassword: 'Password attuale',
        pleaseEnterCurrentPassword: 'Inserisci la password attuale',
        passwordStrength: 'Sicurezza',
        weak: 'Debole',
        fair: 'Discreta',
        good: 'Buona',
        strong: 'Forte',
        passwordUpdated: 'Password modificata con successo',
        languagePreference: 'Lingua',
        languageHint: 'Scegli la lingua di menu, etichette e date.',
        english: 'Inglese',
        italian: 'Italiano',
        accountLabel: 'Account',
        userIdLabel: 'ID utente',
        viewProfile: 'Vedi profilo',
        profilerSetting: 'Profilo',
        securityfleSetting: 'Sicurezza',
        pleaseEnterYourNewpassword: 'Per favore, inserisci la tua nuova password!',
        passwordMustBeatleat: 'La password deve essere lunga almeno 8 caratteri!',
        confirlnewpassword: 'Conferma la nuova password',
        changePasswrdButton: 'Cambia password',
        newpassword: 'Nuova password',
        pleaseConfirmNewpassword: 'Per favore conferma la tua nuova password!',
        passwordDonotMatch: 'Le password non corrispondono!',
        needHelp: 'Hai bisogno di aiuto?',
        checkOurDocs: 'Per favore consulta la nostra documentazione',
        reports: 'Rapporti',
        map: 'Mappa',
        noDeviceFound: 'Nessun dispositivo trovato',
        selectLineType: 'Seleziona tipo di linea',
        dateRange: 'Intervallo di date',
        addOrganization: "Aggiungi Organizzazione",
        ledScreenHeading: "Guidato",
        organizations: "Organizzazioni",
        organizationList: "Elenco Organizzazioni",
        orgName: "Nome dell'organizzazione",
        website: "Sito web",
        action: "Azione",
        orgNotFound: "Nessuna organizzazione trovata",
        addOrgToSeeItsList: "Aggiungi un'organizzazione per vedere l'elenco",
        orgDetailsHeading: "Dettagli dell'organizzazione",
        editOrgText: "Modifica Organizzazione",
        details: "Dettagli",
        pleaseEnterOrgName: "Inserisci il nome dell'organizzazione",
        enterOrgName: "Inserisci il nome dell'organizzazione",
        enterWebsite: "Inserisci il sito web",
        deleteheading: "Sei sicuro di voler eliminare",
        orgText: "questa organizzazione",
        logo: "Carica il logo",
        pleaseUploadLogo: "Si prega di caricare il logo",
        orgDetailsHeading: "Dettagli dell'organizzazione",
        totalUsers: "Utenti totali",
        deviceList: 'Elenco dispositivi',
        selectAll: "Seleziona Tutto",
        searchUsers: "Cerca Utenti...",
        clearAll: "Cancella Tutto",
        searchDevices: "Cerca dispositivo, seriale, ID dispositivo...",
        searchVehicles: "Cerca veicolo, targa, ID dispositivo...",
        sortByCreated: "Ordina per",
        newestFirst: "Più recenti",
        oldestFirst: "Meno recenti",
        searchOrganizations: "Cerca Organizzazioni...",
        organizationSelect: "Seleziona Organizzazioni",
        areYouSureYouWantToDltThisDevice: "Sei sicuro di voler eliminare questo Dispositivo?",
        areYouSureYouWantToDltThisOrganization: "Sei sicuro di voler eliminare questa Organizzazione?",
        areYouSureYouWantToDltThisVehicle: "Sei sicuro di voler eliminare questo Veicolo?",
        areYouSureYouWantToDltThisUser: "Sei sicuro di voler eliminare questo utente?",
        vehicleDetailsHeading: "Dettagli Veicolo",
        vehicleNameLabel: "Nome Veicolo",
        licensePlateLabel: "Targa",
        vehicleModelLabel: "Modello Veicolo",
        yearOfManufactureLabel: "Anno di Produzione",
        vehicleCategoryLabel: "Categoria Veicolo",
        operationStartDateLabel: "Data Inizio Operazioni",
        techMaintenanceNotesLabel: "Note Manutenzione Tecnica",
        deviceTypeRouter: "Router",
        deviceTypePassengerCounters: "Contapasseggeri",
        deviceTypeValidators: "Validatori",
        deviceTypeLcdDisplays: "Display LCD",
        deviceTypeDvr: "DVR",
        deviceTypeXpad: "Xpad",
        registeringNumber: 'Matricola',
        monthJan: "Gen",
        monthFeb: "Feb",
        monthMar: "Mar",
        monthApr: "Apr",
        monthMay: "Mag",
        monthJun: "Giu",
        monthJul: "Lug",
        monthAug: "Ago",
        monthSep: "Set",
        monthOct: "Ott",
        monthNov: "Nov",
        monthDec: "Dic",
        selectDate: "Seleziona una data",
        selectYear: "Seleziona l'anno di fabbricazione",
        deleteUser: "Elimina utente",
        deleteDevice: "Elimina dispositivo",
        deleteVehicle: "Elimina veicolo",
        deleteOrganization: "Elimina organizzazione",
        noVehicleAssigned: "Nessun veicolo assegnato",
        createdBy: "Creato da",
        startDate: "Data di inizio",
        endDate: "Data di fine",
        locationNotFound: "Posizione non trovata per questo router",
        deviceLocation: "Posizione del dispositivo",
        vehicleInformation: "Informazioni veicolo",
        passengerCounterTitle: "Contapasseggeri",
        liveLocation: "Posizione in tempo reale",
        attachedDevices: "Dispositivi collegati",
        vehicleLocationMap: "Posizione e linea del veicolo",
        noVehicleLocation: "Nessuna posizione GPS per questo veicolo (nessun router associato)",
        noVehicleMapData: "Nessuna posizione o linea da mostrare",
        updateOrganization: "Aggiorna organizzazione",
        noUserFound: "Nessun utente trovato",
        noOrganizationsFound: "Nessuna organizzazione trovata",
        vehicleDeleted: "Veicolo eliminato con successo",
        allFieldsRequired: "Tutti i campi sono obbligatori.",
        vehicleAdded: "Veicolo aggiunto con successo",
        unauthorizedEdit: "Puoi modificare solo i veicoli che hai creato tu",
        deviceDeleted: "Dispositivo eliminato con successo",
        unauthorizedDeviceEdit: "Puoi modificare solo i dispositivi che hai creato tu",
        deviceUpdated: "Dispositivo aggiornato con successo!",
        organizationRequired: "Organizzazione obbligatoria",
        apnRequired: "APN è obbligatorio!",
        vpnCertificateNamesRequired: "I nomi del certificato VPN sono obbligatori!",
        vpnIPRequired: "L'IP VPN è obbligatorio!",
        passengerIpRequired: "IP passeggero è obbligatorio!",
        passengerCounterPositioningRequired: "La posizione è obbligatoria!",
        validatorPositioningRequired: "La posizione è obbligatoria!",
        terminalIdRequired: "ID terminale è obbligatorio!",
        validatorIpRequired: "IP validatore è obbligatorio!",
        posSerialNumberRequired: "Il numero di serie POS è obbligatorio!",
        lcdIpRequired: "IP LCD è obbligatorio!",
        mdvrIpRequired: "IP MDVR è obbligatorio!",
        xpadIpRequired: "IP XPAD è obbligatorio!",
        userAddSuccess: "Utente aggiunto con successo.",
        userUpdated: "Utente aggiornato con successo.",
        selectRoleToUpdate: "Seleziona un ruolo da aggiornare.",
        deletedSuccess: "Eliminato con successo.",
        peopleCountertxt: "Contatore di Persone",

        // Parking System Translations
        parkingSystem: "Sistema Parcheggio",
        parkingList: "Lista Parcheggi",
        addParking: "Aggiungi Parcheggio",
        editParking: "Modifica Parcheggio",
        parkingDetails: "Dettagli Parcheggio",
        plateNumber: "Numero Targa",
        enterPlateNumber: "Inserisci numero targa",
        pleaseEnterPlateNumber: "Per favore inserisci il numero targa",
        amount: "Importo",
        enterAmount: "Inserisci importo",
        entryTime: "Ora di Ingresso",
        exitTime: "Ora di Uscita",
        paymentTime: "Ora di Pagamento",
        statusPending: "In Attesa",
        statusActive: "Attivo",
        statusCompleted: "Completato",
        statusEntered: "Entrato",
        statusExited: "Uscito",
        statusPaid: "Pagato",
        pleaseSelectStatus: "Per favore seleziona lo stato",
        parkingAdded: "Record parcheggio aggiunto con successo",
        parkingUpdated: "Record parcheggio aggiornato con successo",
        parkingDeleted: "Record parcheggio eliminato con successo",
        noParkingFound: "Nessun record di parcheggio trovato",
        noParkingHistory: "Nessuna cronologia di parcheggio disponibile",
        addParkingToSee: "Aggiungi un record di parcheggio per vederlo qui",
        confirmDeleteParking: "Sei sicuro di voler eliminare questo record di parcheggio?",
        deleteParking: "Elimina Parcheggio",
        searchParking: "Cerca per numero targa...",
        downloadSuccess: "Report scaricato con successo",
        downloadReport: "Scarica Rapporto",
        sessionCode: "Codice Sessione",
        qrCode: "Codice QR",
        viewQRCode: "Visualizza Codice QR",
        entryGate: "Ingresso Gate",
        exitGate: "Uscita Gate",
        paymentProvider: "Fornitore di Pagamento",
        notes: "Note",
        clearFilters: "Cancella Filtri",
        dateRange: "Intervallo di Date",
        totalEntered: "Totale Entrati",
        totalPaid: "Totale Pagati",
        totalExited: "Totale Usciti",

        searchdevicetype: "Tipo di dispositivo di ricerca...",
        noDeviceTypesFound: "Nessun tipo di dispositivo trovato",
        getPeoplecounterReport: "Ottieni il rapporto del contatore passeggeri",
        vehicleUpdated: "Veicolo aggiornato con successo.",
        downloadReport: "Scarica Rapporto",
        downloadDetailReport: "Scarica Rapporto Dettagliato",
        viewDetailReport: "Visualizza Rapporto Dettagliato",
        viewReport: "Visualizza Rapporto",
        detailReportTitle: "Rapporto Dettagliato Passeggeri",
        timeTxt: "Ora",
        serialNoTxt: "N.",
        closeTxt: "Chiudi",
        validator: "Validatore",
        deletedSuccess: 'Eliminato con successo.',
        details: 'Dettagli',
        action: 'Azione',
        deleteheading: 'Sei sicuro di voler eliminare',
        deviceQuestion: 'Dispositivo',
        vechicleQuestion: 'Veicolo',
        association: 'Associazione',
        areYouSure: 'Sei sicuro?',
        validatorList: "Elenco dei validatori",
        validator: "Validatore",
        deletedSuccess: "Eliminato con successo.",
        details: "Dettagli",
        action: "Azione",
        deleteheading: "Sei sicuro di voler eliminare",
        deviceQuestion: "Dispositivo",
        vechicleQuestion: "Veicolo",
        association: "Associazione",
        areYouSure: "Sei sicuro?",
        ipAddress: "Indirizzo IP",
        portNumber: "Numero di Porta",
        firmwareVersion: "Versione firmware",
        namePlateCode: "Codice piastra",
        enableCc: "Abilita CC",
        customerName: "cliente",
        agencyId: "ID Agenzia",
        terminalId: "ID Terminale",
        useMoney: "Usa Denaro",
        maxTicket: "Massimo Biglietti",
        turnstileStatus: "Stato Tornello",
        tapOnFly: "Tap On Fly",
        checkSsh: "Verifica SSH",
        areYouSureYouWantToDltThisDevice: "Sei sicuro di voler eliminare questo Dispositivo?",
        areYouSureYouWantToDltThisValidator: "Sei sicuro di voler eliminare questo Validatore?",
        noIpAddressesFound: "Nessun indirizzo IP trovato",
        searchIpAddresses: "Cerca indirizzi IP",
        clearAll: "Cancella tutto",
        selectAll: "Seleziona tutto",
        port: "Porta",
        noValidatorsFound: "Nessun validatore trovato",
        addValidatorToSee: "Aggiungi un validatore per vederlo qui",
        addValidator: "Aggiungi Validatore",
        manageValidators: "Gestisci Validatori",
        exportPdf: "Esportare PDF",
        totalValidators: "Totale Validatori",
        totalRecord: "Totale Record",
        validatorLog: "Registri Validatore",
        validatorManagement: "Gestisci Validatori",
        addValidator: "Aggiungi Validatore",
        editValidator: "Modifica Validatore",
        deleteValidator: "Elimina Validatore",
        areYouSureYouWantToDltThisValidator: "Sei sicuro di voler eliminare questo Validatore?",
        add: "Aggiungi",
        update: "Aggiorna Validatori",
        apn: "APN",
        vpnCertificateNames: "Nomi del certificato VPN",
        vpnIP: "IP VPN",
        vpnIP: "IP VPN",
        passengerIp: "IP Passeggero",
        passengerCounterPositioning: "Posizionamento (anteriore, posteriore, centrale)",
        validatorPositioning: "Posizionamento (anteriore, posteriore, centrale)",
        terminalId: "ID Terminale",
        validatorIp: "IP Validatore",
        posSerialNumber: "Numero di serie POS",
        lcdIp: "IP LCD",
        mdvrIp: "IP MDVR",
        xpadIp: "IP XPAD",
        apnRequired: "APN è obbligatorio!",
        vpnCertificateNamesRequired: "I nomi del certificato VPN sono obbligatori!",
        vpnIPRequired: "L'IP VPN è obbligatorio!",
        passengerIpRequired: "IP passeggero è obbligatorio!",
        passengerCounterPositioningRequired: "La posizione è obbligatoria!",
        validatorPositioningRequired: "La posizione è obbligatoria!",
        terminalIdRequired: "ID terminale è obbligatorio!",
        validatorIpRequired: "IP validatore è obbligatorio!",
        posSerialNumberRequired: "Il numero di serie POS è obbligatorio!",
        lcdIpRequired: "IP LCD è obbligatorio!",
        mdvrIpRequired: "IP MDVR è obbligatorio!",
        xpadIpRequired: "IP XPAD è obbligatorio!",
        optionFront: "Anteriore",
        optionRear: "Posteriore",
        optionCentral: "Centrale",
        lastUpdated: "Ultimo aggiornamento",
        internal4g: "Interno 4G",
        external5g: "Esterno 5G",
        internal5g: "Interno 5G",
        uploadVehicle: "Carica i dati del veicolo",
        selectExcelFile: "Seleziona File Excel",
        online: "In linea",
        offline: "Non in linea",
        unknown: "Sconosciuta",
        getPDF: "Scarica Pdf",
        selectVehicle: "Seleziona Veicolo",
        startRouteMessage: "Il veicolo è partito da",
        pastStops: "Fermate Precedenti",
        reachedAt: "Raggiunta alle",
        stoppedFor: "Fermato per",
        lineLabel: "Linea",
        towards: "per",
        onTimeChip: "In orario",
        delayChip: "In ritardo",
        earlyChip: "In anticipo",
        awaitingGpsChip: "In attesa del GPS",
        arriveInShort: "tra",
        arrivingNow: "in arrivo",
        nextRunAt: "Prossima corsa",
        scheduledShort: "Previsto",
        estimatedShort: "Stimato",
        liveFromSchedule: "Orari dal programma ufficiale",
        minutes: "min",
        currentBusLocation: "Posizione Attuale dell'Autobus",
        nextStops: "Prossime Fermate",
        reachIn: "Arrivo previsto in",
        noRouteData: "Nessun dato di percorso disponibile",
        loadingMap: "Caricamento mappa...",
        vehicleRouteTitle: "Percorso del veicolo",
        routeForecastLink: "Previsione percorso",
        openRouteForecast: "Apri la previsione live del percorso in una nuova scheda",
        noRouteFound: "Nessun percorso trovato",
        journeyStartedMessage1: "Il",
        journeyStartedMessage2: "ha iniziato il suo viaggio alle",
        backColor: 'Colore di Sfondo',
        textColor: 'Colore Testo',
        mode: "Modalità",
        font: "Font",
        margin: "Margine",
        panelList: "Elenco dei pannelli",


        updatePenal: "Aggiornamento Penale",
        addPenal: "Aggiungere Penale",


        organization: "Organizzazione",
        device: "Dispositivo",
        direction: "Direzione",
        line: "Linea",
        front: "Fronte",
        rear: "Posteriore",
        side: "Lato",
        deleteThisRecord: "Elimina Questo Record",
        cancel: "Annulla",
        view: "Vista",
        panelRole: "Ruolo del Pannello",
        panelModel: "Modello del Pannello",
        text: "Testo",
        effect: "Effetto",
        speed: "Velocità",
        brightness: "Luminosità",
        busLedDeletedSuccessfully: "LED Bus Eliminato Correttamente",
        addBusLed: "Aggiungi LED Bus",
        totalRecord: "Totale Record",
        preview: "Anteprima",
        pleaseSelectAnOrganization: "Seleziona un'Organizzazione",
        selectOrganizationHere: "Seleziona Organizzazione Qui",
        selectDeviceHere: "Seleziona Dispositivo Qui",
        panelUpdatedSuccessfully: "Pannello Aggiornato Correttamente",
        panelAddedSuccessfully: "Pannello Aggiunto Correttamente",
        pleaseSelectAnOrganization: "Per favore, seleziona un'Organizzazione",
        pleaseSelectADevice: "Per favore, seleziona un Dispositivo",

        ledPanelUpdatedSuccessfully: "Pannello LED aggiornato con successo",
        selectOrginisation: "Seleziona Organizzazione",
        line: "Linea",
        pleaseAddLine: "Per favore aggiungi una linea",
        direction: "Direzione",
        pleaseAddDirection: "Per favore aggiungi una direzione",
        client: "Cliente",
        pleaseEnterClient: "Per favore inserisci il cliente Nome",
        selectClient: "Seleziona Cliente",
        pleaseSelectClient: "Per favore seleziona il cliente",
        client: "Cliente",
        geofencing: "Geofencing",
        searchPanel: "Pannello di ricerca...",
        searchClient: "Cerca cliente",
        goBack: "Indietro",
        viewMore: "Visualizza altro",
        areYouSureYouWantToDltThisBusLed: "Sei sicuro di voler eliminare questo Bus LED?",
        deleteBusLed: "Elimina il LED del bus",
        pdfDownloadSuccess: "PDF scaricato con successo!",
        pdfDownloadFail: "Download del rapporto non riuscito.",
        ipAddress: "Indirizzo IP",
        portNumber: "Numero di Porta",
        enableCc: "Abilita CC",
        status: "Stato",
        regNumber: "Matricola",
        company: "Azienda",
        customerName: "Nome Cliente",
        terminalId: "ID Terminale",
        useMoney: "Usa Soldi",
        maxTicket: "Biglietto Massimo",
        tapOnFly: "Tap On Fly",
        checkSsh: "Controlla SSH",
        namePlateCode: "Codice Targa",
        firmwareVersion: "Versione Firmware",
        lastUpdated: "Ultimo Aggiornamento",
        action: "Azione",
        enabled: "Abilitato",
        disabled: "Disabilitato",
        online: "Online",
        offline: "Offline",
        unknown: "Sconosciuto",
        search: "Cerca",
        noIpFound: "Nessun IP Trovato",
        parking: "Parcheggio",
        enterNotes: "Inserisci le note",
        cameraMappings: "Mappature della fotocamera",
        cameraMappingList: "Elenco mappature telecamera",
        cameraName: "Nome telecamera",
        cameraId: "Identificativo della fotocamera",
        deviceId: "ID dispositivo",
        channelNo: "Canale n",
        gateId: "Identificativo del cancello",
        gateType: "Tipo di cancello",
        laneName: "Sentiero",

        enterDeviceId: "Inserisci ID dispositivo",
        deviceIdRequired: "L'ID dispositivo è obbligatorio",
        enterCameraId: "Inserisci ID telecamera",
        cameraIdRequired: "L'ID telecamera è obbligatorio",
        enterChannelNo: "Inserisci numero canale",
        channelNoRequired: "Il numero canale è obbligatorio",
        enterGateId: "Inserisci ID cancello",
        gateIdRequired: "L'ID cancello è obbligatorio",
        entry: "Entrata",
        exit: "Uscita",
        enterDescription: "Inserisci descrizione",
        enterLane: "Inserisci corsia",
        addCameraMapping: "Aggiungi mappatura telecamera",
        editCameraMapping: "Modifica mappatura telecamera",
        cameraMappingAdded: "Mappatura telecamera aggiunta con successo",
        cameraMappingUpdated: "Mappatura telecamera aggiornata con successo",
        cameraMappingDeleted: "Mappatura telecamera eliminata con successo",
        deleteCameraMapping: "Mappatura telecamera eliminata con successo",
        admin: "Ammin",
        updateCameraMapping: "Aggiorna la mappatura della telecamera",
        areYouSureYouWantToDltThisCameraList: "Sei sicuro di voler eliminare questo elenco di fotocamere?",
        edit: "Modifica",
        enterCameraName: "Inserisci nome telecamera",
        directionRequired: "Inserisci la direzione",
        enterDirection: "Inserisci direzione (entrata, uscita, parcheggio)",
        enterLocation: "Inserisci posizione",
        adding: "Aggiunta in corso...",
        updating: "Aggiornamento in corso...",
        downloadError: "Download non riuscito",
        sessionExpired: "Sessione scaduta. Accedi di nuovo.",
        fetchCameraMappingError: "Impossibile recuperare i dati di mappatura della telecamera.",
        errorFetchingCameraMappings: "Errore durante il recupero delle mappature delle telecamere.",
        failedToAddCameraMapping: "Impossibile aggiungere la mappatura della telecamera.",
        errorAddingCameraMapping: "Errore durante l'aggiunta della mappatura della telecamera.",
        failedToUpdateCameraMapping: "Impossibile aggiornare la mappatura della telecamera.",
        errorUpdatingCameraMapping: "Errore durante l'aggiornamento della mappatura della telecamera.",
        failedToDeleteCameraMapping: "Impossibile eliminare la mappatura della telecamera.",
        errorDeletingCameraMapping: "Errore durante l'eliminazione della mappatura della telecamera.",
        qrCodeNotAvailable: "Codice QR non disponibile",
        pdfNotAvailable: "PDF non disponibile",
        isActive: "È Attivo",
        all: "Tutti",
        inactive: "Non attivo",
        parkingQRDetails: "Dettagli QR sul parcheggio",
        viewParkingSessionDetails: "Visualizza i dettagli della sessione di parcheggio associata a questo codice QR",
        downloadSlip: "Scarica Slip",
        parkingTicket: "Biglietto del Parcheggio",
        sessionCode: "Codice Sessione",
        plateNumber: "Numero di Targa",
        correctedPlate: "Targa Corretta",
        sessionStatus: "Stato della Sessione",
        paymentStatus: "Stato del Pagamento",
        entryTime: "Orario di Ingresso",
        paymentTime: "Orario di Pagamento",
        exitTime: "Orario di Uscita",
        exitAllowedUntil: "Uscita Consentita Entro",
        paymentAmount: "Importo Pagato",
        laneNo: "Corsia N.",
        platePicture: "Foto della Targa",
        plateAlt: "Targa",
        noPlatePicture: "Nessuna foto della targa disponibile",
        qrToken: "Token QR",
        deviceId: "ID Dispositivo",
        cameraId: "ID Telecamera",
        channel: "Canale",
        invalidQr: "QR Parcheggio non Valido",
        noSessionFound: "Nessuna sessione di parcheggio trovata per questo codice QR",
        parkingAvailability: "Disponibilità di parcheggio",
        loadingAvailability: "Caricamento disponibilità...",
        catania: "Catania",
        realTimeAvailability: "Disponibilità posti auto in tempo reale",
        remainingFreeSpots: "Posti liberi rimanenti",
        availableSpots: "posti disponibili",
        occupancy: "Occupazione",
        lastUpdate: "Ultimo aggiornamento:",
        totalSpots: "Posti totali",
        occupiedSpots: "Posti occupati",
        parkingStallNo: "Posto auto n",
        location: "Posizione",
        description: "Descrizione",
        enterParkingStall: "Entrare nel parcheggio n.",
        parkinglotName: "Nome del parcheggio",
        addlotButton: "Aggiungi parcheggio",
        searchlots: "Cerca parcheggi...",
        nolotsFound: "Nessun parcheggio trovato",
        addlotToSeeList: "Aggiungi un parcheggio per vederlo qui.",
        parkinglotsHeading: "Aree di parcheggio",
        lotDetailsHeading: "Dettagli del parcheggio",
        editlotText: "Modifica parcheggio",
        updatelotButton: "Aggiorna parcheggio",
        enterlotName: "Inserisci il nome del parcheggio",
        totalSpaces: "Spazi totali",
        enterTotalSpaces: "Inserisci il numero di posti",
        enterAddress: "Inserisci l'indirizzo",
        organizationSelect: "Seleziona organizzazione",
        organizations: "Organizzazione",
        areYouSureYouWantToDltThislot: "Sei sicuro di voler eliminare questo parcheggio?",
        deletelot: "Elimina parcheggio",
        parkinglotList: "Elenco parcheggi",
        live: "VIVERE",
        totalSlots: "Posti Totali",
        available: "Disponibili",
        occupied: "Occupati",
        occupancy: "Occupazione",
        inUse: "in uso",
        parkingSlotsHeading: "Stalli di Parcheggio",
        free: "LIBERO",
        busy: "OCCUPATO",
        noSlotsConfigured: "Nessuno stallo di parcheggio configurato",
        updateParking:"Aggiorna parcheggio",
        viewParkingLots: "Visualizza parcheggi",

        // Override earlier Italian translations
        routes: 'Percorsi',
        datetxt: 'Tempo',
        online: 'In linea',
        offline: 'Non in linea',

        // New keys for previously hardcoded UI strings
        count: 'contare',
        noData: 'Nessun dato',
        noDataAvailable: 'Nessun dato disponibile',
        noVehicleDataAvailable: 'Nessun dato veicolo disponibile',
        loadingDeviceLocation: 'Caricamento posizione dispositivo...',
        pleaseEnterIpAddress: 'Inserisci l\'indirizzo IP',
        invalidIPv4: 'Formato IPv4 non valido (es. 192.168.0.1)',
        refreshValidatorsMessage: 'L\'elenco dei validatori è in fase di aggiornamento e potrebbe richiedere del tempo.',
        refreshValidatorsSuccess: 'Aggiornamento elenco validatori riuscito',
        refreshValidatorsFailed: 'Aggiornamento validatori non riuscito',
        pleaseCompleteFormRequirements: 'Si prega di completare i requisiti del modulo',
        pleaseFillOutRequiredFields: 'Compila i campi obbligatori {{roles}}',
        pleaseFillOutFrontSideRearRequiredFields: 'Si prega di compilare i campi obbligatori Frontale, Laterale e Posteriore',
        viewFront: 'Visualizza frontale',
        viewSide: 'Visualizza laterale',
        viewRear: 'Visualizza posteriore',
        selectEntryTime: 'Seleziona orario di ingresso',
        selectPaymentTime: 'Seleziona orario di pagamento',
        selectExitTime: 'Seleziona orario di uscita',
        errorUpdatingParkingSession: 'Errore nell\'aggiornamento della sessione di parcheggio.',
        actions: 'Azioni',
        plateRequired: 'Inserisci il numero di targa',
        pleaseEnterParkingLotName: 'Inserisci il nome del parcheggio',
        pleaseEnterAddress: 'Inserisci l\'indirizzo',
        pleaseEnterTotalSpaces: 'Inserisci il numero totale di posti',
        pleaseEnterValidNumber: 'Inserisci un numero valido',
        totalSpacesAtLeast1: 'I posti totali devono essere almeno 1',
        totalSpacesMax: 'I posti totali non possono superare 100000',
        totalSpacesWholeNumber: 'I posti totali devono essere un numero intero',
        pleaseSelectOrganization: 'Seleziona un\'organizzazione',
        fileRequired: 'Il file è obbligatorio',
        noDataFound: 'Nessun dato trovato',
        uploadExcelFile: 'Carica file Excel',
        teltonikaInstructionsGuide: 'Guida alle istruzioni Teltonika',
        and: 'e',
        requiredFields: 'campi obbligatori',
        routerType: 'Tipo di router',
        selectRouterType: 'Seleziona il tipo di router',
        downloadPDF: 'Scarica il PDF',
    },
    en: {
        updateParking:"Update Parking",
        viewParkingLots: "View Parking Lots",
        live: "LIVE",
        totalSlots: "Total Slots",
        available: "Available",
        occupied: "Occupied",
        occupancy: "Occupancy",
        inUse: "in use",
        parkingSlotsHeading: "Parking Slots",
        free: "FREE",
        busy: "BUSY",
        noSlotsConfigured: "No parking slots configured",
        parkinglotList: "Parking lots List",
        parkinglotName: "Parking lot Name",
        addlotButton: "Add Parking lot",
        searchlots: "Search Parking lots...",
        nolotsFound: "No Parking lots Found",
        addlotToSeeList: "Add a parking lot to see it here.",
        parkinglotsHeading: "Parking lots",
        lotDetailsHeading: "Parking lot Details",
        editlotText: "Edit Parking lot",
        updatelotButton: "Update lot",
        enterlotName: "Enter lot name",
        totalSpaces: "Total Spaces",
        enterTotalSpaces: "Enter total spaces",
        enterAddress: "Enter address",
        organizationSelect: "Select organization",
        organizations: "Organization",
        areYouSureYouWantToDltThislot: "Are you sure you want to delete this parking lot?",
        deletelot: "Delete Parking lot",
        enterParkingStall: "Enter Parking Stall No",
        description: "Description",
        location: "Location",
        parkingStallNo: "Parking Stall No",
        loadingAvailability: "Loading availability...",
        catania: "Catania",
        realTimeAvailability: "Real-time parking space availability",
        remainingFreeSpots: "Remaining free spots",
        availableSpots: "Available spots",
        occupancy: "Occupancy",
        lastUpdate: "Last update:",
        totalSpots: "Total spots",
        occupiedSpots: "Occupied spots",
        parkingAvailability: "Parking Availability",
        invalidQr: "Invalid Parking QR",
        noSessionFound: "No parking session found for this QR code",
        platePicture: "Plate Picture",
        plateAlt: "Plate",
        noPlatePicture: "No plate picture available",
        qrToken: "QR Token",
        deviceId: "Device ID",
        cameraId: "Camera ID",
        channel: "Channel",
        entryTime: "Entry Time",
        paymentTime: "Payment Time",
        exitTime: "Exit Time",
        exitAllowedUntil: "Exit Allowed Until",
        paymentAmount: "Payment Amount",
        laneNo: "Lane No",
        plateNumber: "Plate Number",
        correctedPlate: "Corrected Plate",
        sessionStatus: "Session Status",
        paymentStatus: "Payment Status",
        parkingTicket: "Parking Ticket",
        sessionCode: "Session Code",
        downloadSlip: "Download Slip",
        viewParkingSessionDetails: "View parking session details linked with this QR code",
        parkingQRDetails: "Parking QR Details",
        areYouSureYouWantToDltThisCameraList: "Are you sure you want to delete this camera list?",
        updateCameraMapping: "Update Camera Mapping",
        admin: "Admin",
        ipAddress: "IP Address",
        portNumber: "Port Number",
        enableCc: "Enable CC",
        status: "Status",
        regNumber: "Registration Number",
        company: "Company",
        customerName: "Customer Name",
        terminalId: "Terminal ID",
        useMoney: "Use Money",
        maxTicket: "Max Ticket",
        tapOnFly: "Tap On Fly",
        checkSsh: "Check SSH",
        namePlateCode: "Name Plate Code",
        firmwareVersion: "Firmware Version",
        lastUpdated: "Last Updated",
        action: "Action",
        enabled: "Enabled",
        disabled: "Disabled",
        online: "Online",
        offline: "Offline",
        unknown: "Unknown",
        search: "Search",
        noIpFound: "No IP Found",
        pdfDownloadFail: "Report download failed",
        pdfDownloadSuccess: "PDF Download Successfully",
        deleteBusLed: "Delete Bus LED",
        areYouSureYouWantToDltThisBusLed: "Are you sure you want to delete this Bus Led?",
        viewMore: "View More",
        goBack: "Back",
        searchClient: "Search Client",
        searchPanel: "Search Panel...",
        geofencing: "Geofencing",
        client: "Client",
        pleaseSelectClient: "Please select Client",
        selectClient: "Select Client",
        pleaseEnterClient: "Please enter Client Name",
        client: "Client",
        effectBlink: "Blink",
        ledPanel: "LED Panel",
        code: "Code",
        codePlaceholder: "Select serial number",
        brand: "Brand",
        brandPlaceholder: "Select brand",
        panelFront: "Front",
        panelSide: "Side",
        panelRear: "Rear",
        panelModel: "Panel Model",
        panelModelPlaceholder: "Enter panel model",
        text: "Text",
        textPlaceholder: "Enter text",
        effect: "Effect",
        effectStatic: "Static",
        effectScroll: "Scroll",
        speed: "Speed",
        speedPlaceholder: "Enter speed",
        brightness: "Brightness",
        brightnessPlaceholder: "Enter brightness",
        color: "Color",
        preview: "Preview",
        save: "Save",
        panel: 'Panel',
        vpnIP: "VPN IP",
        loadingMap: "Loading Map...",
        vehicleRouteTitle: "Vehicle Route",
        routeForecastLink: "Route Forecast",
        openRouteForecast: "Open the live route forecast in a new tab",
        noRouteFound: "No route found",
        journeyStartedMessage1: "The",
        journeyStartedMessage2: "began its journey at",
        pastStops: "Past Stops",
        reachedAt: "Reached at",
        stoppedFor: "Stopped for",
        lineLabel: "Line",
        towards: "to",
        onTimeChip: "On time",
        delayChip: "Delay",
        earlyChip: "Early",
        awaitingGpsChip: "Awaiting live GPS",
        arriveInShort: "in",
        arrivingNow: "arriving now",
        nextRunAt: "Next run",
        scheduledShort: "Scheduled",
        estimatedShort: "Estimated",
        liveFromSchedule: "Times from the official schedule",
        minutes: "min",
        currentBusLocation: "Current Bus Location",
        nextStops: "Next Stops",
        reachIn: "Approximate reach in",
        noRouteData: "No route data available",
        startRouteMessage: "The",
        startRouteMessage2: "began its journey at",
        selectVehicle: "Select Vehicle",
        getPDF: "Download PDF",
        online: "Online",
        offline: "Offline",
        unknown: "Unknown",
        uploadVehicle: "Upload Vehicle Data",
        selectExcelFile: "Select Excel File",
        totalRecord: 'Total Record',
        internal4g: "Internal 4G",
        external5g: "External 5G",
        internal5g: "Internal 5G",
        lastUpdated: "Last Updated",
        createdAt: 'Created At',
        refreshButton: 'Refresh',
        status: 'Status',
        regNumber: 'Registration Number',
        apn: "APN",
        vpnCertificateNames: "VPN Certificate Names",
        vpnIP: "VPN IP",
        passengerIp: "Passenger IP",
        passengerCounterPositioning: "Positioning (front, rear, central)",
        validatorPositioning: "Positioning (front, rear, central)",
        terminalId: "Terminal ID",
        validatorIp: "Validator IP",
        posSerialNumber: "POS Serial Number",
        optionFront: "Front",
        optionRear: "Rear",
        optionCentral: "Central",
        lcdIp: "LCD IP",
        mdvrIp: "MDVR IP",
        xpadIp: "Xpad IP",
        apnRequired: "APN is required!",
        vpnCertificateNamesRequired: "VPN Certificate Names are required!",
        vpnIPRequired: "VPN IP is required!",
        passengerIpRequired: "Passenger IP is required!",
        passengerCounterPositioningRequired: "Positioning is required!",
        validatorPositioningRequired: "Positioning is required!",
        terminalIdRequired: "Terminal ID is required!",
        validatorIpRequired: "Validator IP is required!",
        posSerialNumberRequired: "POS Serial Number is required!",
        lcdIpRequired: "LCD IP is required!",
        mdvrIpRequired: "MDVR IP is required!",
        xpadIpRequired: "Xpad IP is required!",
        add: "Add",
        update: "Update Validator",
        addValidator: "Add Validator",
        editValidator: "Edit Validator",
        deleteValidator: "Delete Validator",
        validatorManagement: "Manage Validators",
        validatorLog: "Validator Logs",
        totalRecord: "Total Record",
        exportPdf: "Export PDF",
        totalValidators: "Total Validators",
        manageValidators: "Manage Validators",
        addValidator: "Add Validator",
        noValidatorsFound: "No Validators Found",
        addValidatorToSee: "Add a validator to see it listed here",
        validatorList: "Validators List",
        validator: "Validator",
        deletedSuccess: "Deleted successfully.",
        details: "Details",
        action: "Action",
        deleteheading: "Are you sure you want to delete",
        deviceQuestion: "Device",
        vechicleQuestion: "Vehicle",
        association: "Association",
        areYouSure: "Are you sure?",
        ipAddress: "IP Address",
        portNumber: "Port Number",
        firmwareVersion: "Firmware version",
        namePlateCode: "Nameplate code",
        enableCc: "Enable CC",
        customerName: "Customer",
        agencyId: "Agency ID",
        terminalId: "Terminal ID",
        useMoney: "Use Money",
        maxTicket: "Max Ticket",
        turnstileStatus: "Turnstile Status",
        tapOnFly: "Tap On Fly",
        checkSsh: "Check SSH",
        areYouSureYouWantToDltThisDevice: "Are you sure you want to delete this device?",
        areYouSureYouWantToDltThisValidator: "Are you sure you want to delete this validator?",
        noIpAddressesFound: "No IP Addresses Found",
        searchIpAddresses: "Search IP Addresses",
        clearAll: "Clear All",
        selectAll: "Select All",
        port: "Port",
        teltonikaInstructionDescription: 'A comprehensive guide to configure your Teltonika router for seamless GPS data forwarding using NMEA protocol. This integration enables real-time location tracking and monitoring with minimal setup complexity.',
        teltonikaInstructionHeading: 'Teltonika Instruction',
        teltonikaInstructionDescription: 'A comprehensive guide to configure your Teltonika router for seamless GPS data forwarding using NMEA protocol. This integration enables real-time location tracking and monitoring with minimal setup complexity.',

        overviewHeading: 'Overview',
        overviewText: 'To integrate your Teltonika router with our platform, GPS data must be forwarded via the NMEA Forwarding service. You’ll configure the router to send this data to our provided IP address and port using the specified protocol and prefix.',

        prerequisitesHeading: 'Prerequisites',
        prerequisitesText: 'Before proceeding with the configuration, ensure you have administrative access to your Teltonika router and verify the following server connection details:',
        serverAddress: 'Server Address',
        port: 'Port',
        protocol: 'Protocol',
        prefix: 'Prefix',
        additionalConfirmText: 'Additionally, confirm that:',
        additionalConfirmList1: 'Network connectivity to the destination server is available',
        additionalConfirmList2: 'Router firmware supports NMEA forwarding features',

        configurationHeading: 'Configuration',
        accessRouterInterface: 'Access Router Interface',
        accessRouterInterfaceText: 'Open your web browser and navigate to your router\'s administration panel. The default address is typically 192.168.1.1. Enter your administrator credentials when prompted.',

        navigateToSettings: 'Navigate to NMEA Settings',
        navigateToSettingsText: 'Once logged in, locate the GPS configuration section by following this path:',
        navServices: 'Services',
        navGPS: 'GPS',
        navNMEA: 'NMEA',
        navForwarding: 'NMEA Forwarding',

        enableForwarding: 'Enable and Configure Forwarding',
        enableForwardingText1: 'In the NMEA Forwarding section, enable the forwarding feature and add a new host configuration with the server details provided above.',
        enableForwardingText2: 'Click the ➕ icon to add a new host.',
        enableForwardingText3: 'The configuration should appear similar to this:',
        containConnection: 'Contain Connection',
        containConnectionValue: 'OFF',
        hostName: 'Host Name',

        saveAndVerify: 'Save and Verify',
        saveAndVerifyText: 'Apply your configuration changes and monitor the connection status. The interface should indicate a successful connection to the remote server. GPS data transmission will begin automatically once the connection is established.',

        exampleUIReference: 'Example UI Reference',

        importantNotesHeading: 'Important Notes',
        protocolSelectionNote: 'TCP is recommended over UDP for NMEA forwarding as it ensures reliable data delivery and maintains connection integrity, particularly important for continuous GPS tracking applications.',
        firewallConsiderationsNote: 'Verify that your network firewall and router security settings allow outbound connections to the specified server address and port. Some enterprise networks may require additional configuration.',
        multipleDestinationsNote: 'The router supports forwarding GPS data to multiple host endpoints simultaneously. Simply add additional host configurations if you need to send data to backup servers or different monitoring systems.',
        teltonikaInstruction: 'Teltonika Instructions',
        teltonikaInstructionHeading: 'Teltonika Integration Instructions',
        downloadDetailReport: "Download Detailed Report",
        viewDetailReport: "View Detailed Report",
        viewReport: "View Report",
        detailReportTitle: "Passenger Detailed Report",
        timeTxt: "Time",
        serialNoTxt: "No#",
        closeTxt: "Close",
        downloadReport: "Download Report",
        getPeoplecounterReport: "Get People Counter Report",
        noDeviceTypesFound: "No Device Type Found",
        searchdevicetype: "Search Device type...",
        deleteDevice: "Delete Device",
        peopleCountertxt: "People Counter",

        // Parking System Translations
        parkingSystem: "Parking System",
        parkingList: "Parking List",
        addParking: "Add Parking",
        editParking: "Edit Parking",
        parkingDetails: "Parking Details",
        plateNumber: "Plate Number",
        enterPlateNumber: "Enter plate number",
        pleaseEnterPlateNumber: "Please enter plate number",
        amount: "Amount",
        enterAmount: "Enter amount",
        entryTime: "Entry Time",
        exitTime: "Exit Time",
        paymentTime: "Payment Time",
        statusPending: "Pending",
        statusActive: "Active",
        statusCompleted: "Completed",
        pleaseSelectStatus: "Please select status",
        parkingAdded: "Parking record added successfully",
        parkingUpdated: "Parking record updated successfully",
        parkingDeleted: "Parking record deleted successfully",
        noParkingFound: "No Parking Records Found",
        noParkingHistory: "No parking history available yet",
        addParkingToSee: "Add a parking record to see it listed here",
        confirmDeleteParking: "Are you sure you want to delete this parking record?",
        deleteParking: "Delete Parking",
        searchParking: "Search by plate number...",
        downloadSuccess: "Report downloaded successfully",
        statusEntered: "Entered",
        statusExited: "Exited",
        statusPaid: "Paid",
        sessionCode: "Session Code",
        qrCode: "QR Code",
        viewQRCode: "View QR Code",
        entryGate: "Entry Gate",
        exitGate: "Exit Gate",
        paymentProvider: "Payment Provider",
        notes: "Notes",
        clearFilters: "Clear Filters",
        dateRange: "Date Range",
        totalEntered: "Total Entered",
        totalPaid: "Total Paid",
        totalExited: "Total Exited",

        deletedSuccess: "Deleted successfully.",
        selectRoleToUpdate: "Please select a role to update.",
        userUpdated: "User updated successfully.",
        userAddSuccess: "User added successfully.",
        apnRequired: "APN is required!",
        vehicleUpdated: "Vehicle updated successfully.",
        vpnCertificateNamesRequired: "VPN Certificate Names are required!",
        vpnIPRequired: "VPN IP is required!",
        passengerIpRequired: "Passenger IP is required!",
        passengerCounterPositioningRequired: "Positioning is required!",
        validatorPositioningRequired: "Positioning is required!",
        terminalIdRequired: "Terminal ID is required!",
        validatorIpRequired: "validator IP is required!",
        posSerialNumberRequired: "POS Serial Number is required!",
        lcdIpRequired: "Lcd IP is required!",
        mdvrIpRequired: "Mdvr IP is required!",
        xpadIpRequired: "Xpad IP is required!",
        organizationRequired: "Organization is required.",
        deviceUpdated: "Device updated successfully!",
        deviceDeleted: "Device deleted successfully",
        unauthorizedDeviceEdit: "You can only edit devices that you have created",
        vehicleAdded: "Vehicle added successfully",
        vehicleDeleted: "Vehicle deleted successfully",
        allFieldsRequired: "Required fields are required.",
        noOrganizationsFound: "No organizations found",
        unauthorizedEdit: "You can only edit vehicles that you have created.",
        noUserFound: "No User found",
        locationNotFound: "Location not found of this router.",
        deviceLocation: "Device Location",
        vehicleInformation: "Vehicle information",
        passengerCounterTitle: "Passenger counter",
        liveLocation: "Live location",
        attachedDevices: "Attached devices",
        vehicleLocationMap: "Vehicle location & line",
        noVehicleLocation: "No live position for this vehicle (no router attached)",
        noVehicleMapData: "No position or line to show",
        endDate: "End date",
        createdBy: "Created By",
        startDate: "Start date",
        noVehicleAssigned: "No Vehicle Assigned",
        deleteOrganization: "Delete Organization",
        deleteVehicle: "Delete Vehicle",
        deleteUser: "Delete User",
        selectYear: "Select Manufacture Year",
        selectDate: "Select a Date",
        monthJan: "Jan",
        monthFeb: "Feb",
        monthMar: "Mar",
        monthApr: "Apr",
        monthMay: "May",
        monthJun: "Jun",
        monthJul: "Jul",
        monthAug: "Aug",
        monthSep: "Sep",
        monthOct: "Oct",
        monthNov: "Nov",
        monthDec: "Dec",
        dateTxtReport: "Date",
        registeringNumber: 'Registering number',
        deviceTypeRouter: "Router",
        deviceTypePassengerCounters: "Passenger Counters",
        deviceTypeValidators: "Validators",
        deviceTypeLcdDisplays: "LCD Displays",
        deviceTypeDvr: "DVR",
        deviceTypeXpad: "Xpad",
        vehicleDetailsHeading: "Vehicle Details",
        vehicleNameLabel: "Vehicle Name",
        licensePlateLabel: "License Plate",
        vehicleModelLabel: "Vehicle Model",
        yearOfManufactureLabel: "Year of Manufacture",
        vehicleCategoryLabel: "Vehicle Category",
        operationStartDateLabel: "Operation Start Date",
        techMaintenanceNotesLabel: "Tech Maintenance Notes",
        areYouSureYouWantToDltThisUser: "Are you sure you want to delete this user?",
        areYouSureYouWantToDltThisVehicle: "Are you sure you want to delete this Vehicle?",
        areYouSureYouWantToDltThisDevice: "Are you sure you want to delete this device?",
        areYouSureYouWantToDltThisOrganization: "Are you sure you want to delete this Organization?",
        searchOrganizations: "Search Organizations...",
        organizationSelect: "Select Organizations",
        searchDevices: "Search device, serial, device ID...",
        searchVehicles: "Search vehicle, plate, device ID...",
        sortByCreated: "Sort by",
        newestFirst: "Newest first",
        oldestFirst: "Oldest first",
        clearAll: "Clear All",
        selectAll: "Select All",
        searchUsers: "Search User...",
        userDetailsHeading: "User Detail",
        deviceList: "Device List",
        updateOrganization: 'Update Organization',
        totalUsers: "Total Users",
        logo: "Upload Logo",
        pleaseUploadLogo: "Please upload the logo",
        orgDetailsHeading: "Organization Details",
        addOrganization: "Add Organization",
        organizations: "Organizations",
        organizationList: "Organization List",
        orgName: "Organization Name",
        website: "Website",
        action: "Action",
        orgNotFound: "No Organization Found",
        addOrgToSeeItsList: "Add an organization to see its list",
        orgDetailsHeading: "Organization Details",
        editOrgText: "Edit Organization",
        details: "Details",
        pleaseEnterOrgName: "Please enter organization name",
        enterOrgName: "Enter organization name",
        enterWebsite: "Enter website",
        deleteheading: "Are you sure you want to delete",
        orgText: "this organization",
        txtExitPassengers: "Exit",
        txtRemainingPassengers: "Current Passengers",
        txtEnterPassengers: "Enter",
        txtTotalPassengers: "Total",
        totalPassengers: "Total Passengers",
        totalEnter: "Total Enter",
        totalExit: "Total Exit",
        remainingPassengers: "Remaining Passengers",
        roleSelectType: 'Select Role Type',
        selectRoleMessage: 'Please select a role!',
        qrCodeScannerTitle: 'QR Code Scanner',
        scanQr: 'Scan QR',
        enterUserName: "Enter name",
        enterPassword: "Enter password",
        enterEmailLabel: "Email",
        enterEmail: "Enter email",
        phoneNumber: "Phone number",
        enterPhoneNumber:"Enter phone number",
        roleSelect: "Role",
        cancelButton: "Cancel",
        userNameList: "Users list",
        seePassword: "Change Password",
        accessAllow: "Access allowed",
        userText: "User",
        editUserText: "Edit user",
        updateUserButton: "Update user",
        pleaseEnterName: "Please enter your name!",
        pleaseEnterPasword: "Please enter your password!",
        pleaseEnterEmail: "Please enter your email!",
        pleaseEnterPhone: "Please enter your phone number!",
        paswordtxt: "Password",
        addUserButton: 'Add User',
        deleteheading: 'Delete',
        deviceQuestion: 'Device',
        deviceAdded: 'Devices Added successfully',
        entervechicleName: 'Enter Vehicle Name',
        enterVehicle: 'Enter Vehicle',
        selectLineType: "Select Line Type",
        pleaseEntervechicleName: 'Please Enter Vehicle Name',
        vechicleName: 'Vehicle Name',
        deviceName: 'Device Name',
        devicePlaceholder: 'Enter Device Name',
        pleaseEnterDevicePlaceholder: 'Please Enter Device Name',
        logout: 'Logout',
        signIn: 'Sign In',
        search: 'Search',
        dashboard: 'Dashboard',
        menuGroupOverview: 'Overview',
        menuGroupFleet: 'Fleet',
        menuGroupAnalytics: 'Analytics',
        menuGroupParking: 'Parking',
        menuGroupAdmin: 'Administration',
        menuGroupSystem: 'System',
        vehicles: 'Vehicles',
        gtfs: 'GTFS',
        gtfsName: 'GTFS Name',
        editGtfsName: 'Edit GTFS Name',
        gtfsList: 'GTFS List',
        gtfsDetails: 'GTFS Details',
        addGtfs: 'Add GTFS',
        routes: 'Routes',
        stops: 'Stops',
        attachedVehicles: 'Attached Vehicles',
        attachVehicle: 'Attach Vehicle',
        attachOrgHint: 'Only vehicles of this organization are listed; the GTFS belongs to it.',
        searchRoute: 'Search line or route',
        selectVehiclePlaceholder: 'Select vehicles (name, plate or registering number)',
        detachVehicle: 'Detach Vehicle',
        changeLineTrip: 'Change line / trip',
        currentLine: 'Current line',
        newLine: 'New line',
        newTrip: 'New trip',
        optionalWholeLine: 'optional: empty = assign the line only',
        selectLine: 'Select a line',
        selectTrip: 'Select a trip',
        shift: 'Shift',
        inUseBy: 'in use by',
        forceReassign: 'Override even if the trip is already assigned to another vehicle',
        reasonOptional: 'Reason (optional)',
        reassignNote: 'The change is immediate: the route panel and the public displays (Route Forecast) show it within 30 seconds. The manual assignment stays locked until the end of the service day; history is preserved.',
        applyChange: 'Apply',
        confirmLineChange: 'Confirm line change',
        confirmLineChangeText: 'This change updates live public data. Move',
        toLine: 'to line',
        lineChanged: 'Line updated',
        lineChangeFailed: 'Line change failed',
        manualAssignment: 'Manual assignment',
        lockedUntil: 'locked until',
        noActiveTrips: 'No active trips today for this line',
        assignmentHistory: 'Assignment history',
        noAssignmentHistory: 'No changes recorded',
        wholeLine: 'whole line',
        forced: 'forced',
        moveToGtfs: 'Move to another GTFS',
        selectVehicle: 'Select vehicle',
        selectGtfsFeed: 'Select GTFS',
        vehicleAttached: 'Vehicle attached to GTFS',
        vehicleMoved: 'Vehicle moved to the new GTFS',
        vehicleDetached: 'Vehicle detached from GTFS',
        noVehiclesToAttach: 'No vehicles available to attach',
        attachedToOtherGtfs: 'attached to',
        attachLockedHint: 'Vehicles already attached to another GTFS must be detached there first.',
        areYouSureDetachVehicle: 'Are you sure you want to detach this vehicle from the GTFS?',
        lineDetected: 'line detected',
        lineSuggested: 'line suggested from GPS history',
        linePendingNotMoving: 'vehicle not moving — the line will be detected once it starts',
        lineStatus: 'Line status',
        confirmed: 'Confirmed',
        unconfirmed: 'Unconfirmed',
        shifts: 'Shifts',
        shift: 'Shift',
        liveNow: 'Live now',
        noShifts: 'No shifts found for this line',
        noShiftAssigned: 'No shift',
        vehicle: 'Vehicle',
        routeHistory: 'Route History',
        routeHistorySubtitle: 'Daily trips of every vehicle: kilometres, speed and schedule adherence.',
        routesToday: 'Routes Today',
        totalTrips: 'Total Trips',
        vehiclesWithTrips: 'Vehicles in service',
        vehiclesWithRouter: 'vehicles with router',
        onSchedule: 'On schedule',
        offSchedule: 'Off schedule',
        avgAdherence: 'Avg Adherence',
        tripsPerLine: 'Trips per Line',
        lineVehicles: 'Vehicles on this line',
        vehiclesShort: 'vehicles',
        attachedToLine: 'attached to the line',
        ranTodayOnly: 'ran the line today',
        tripsToday: 'trips today',
        lastRunAt: 'last run',
        noVehiclesOnLine: 'No vehicle attached to or running this line today',
        searchVehicle: 'Search vehicle, plate or line',
        allStatuses: 'All statuses',
        allOrganizations: 'All organizations',
        onlyVehiclesWithTrips: 'Only vehicles with trips',
        noTripsForDay: 'No trips recorded for this date',
        noTripsHint: 'Pick another day or check that the vehicles have an active router.',
        noTripsForVehicle: 'No trips for this vehicle',
        mapMatchingInProgress: 'Processing traces…',
        viewRouteHistory: 'View route history',
        statusBreakdown: 'Trip status',
        passengersTxt: 'Passengers',
        perTrip: 'per trip',
        retryTxt: 'Retry',
        routeStatsLoadFailed: "Couldn't load today's routes",
        routeStatsLoadFailedHint: 'The server is still processing the fleet data. Try again in a few seconds.',
        showAllTrips: 'Show all trips',
        showFewerTrips: 'Show fewer',
        more: 'more',
        kmTraveled: 'KM Traveled',
        scheduledDistance: 'Scheduled Distance',
        avgSpeed: 'Avg Speed',
        maxSpeed: 'Max Speed',
        adherence: 'Adherence',
        normal: 'Normal',
        abnormal: 'Abnormal',
        noSchedule: 'No scheduled trip',
        noRoutesFound: 'No routes found for this date',
        uploaded: 'Uploaded',
        searchGtfs: 'Search GTFS...',
        noGtfsFound: 'No GTFS found',
        addGtfsToSee: 'Upload a GTFS package to see it here',
        direction: 'Direction',
        duration: 'Duration',
        trips: 'Trips',
        firstDeparture: 'First Departure',
        lastArrival: 'Last Arrival',
        mapView: 'Map view',
        stopsView: 'Stop list',
        startStop: 'Start',
        endStop: 'End',
        noLineGeometry: 'No geometry available for this line',
        noStopCoordinates: 'The stops of this line have no real coordinates yet (placeholders from the Excel conversion).',
        stopCoordinates: 'Stop coordinates',
        stopCoordinatesIntro: 'Stops imported from Excel without coordinates are parked on a placeholder. Here they get their real coordinates: looked up among the stops the platform already holds for the Chieti area and, if you upload one, in a stops file (CSV or GTFS zip), matched by stop code and then by name.',
        stopCoordinatesFiles: 'Stops file (optional)',
        stopsFileHint: 'CSV with stop_id, stop_code, stop_name, stop_lat, stop_lon (or a GTFS zip). Matched by code, then by name; it takes precedence over the automatic lookup.',
        selectStopsFile: 'Drop a file here or click to choose one',
        resolveCoordinates: 'Assign coordinates',
        coordsResolvedNow: 'stops resolved',
        coordsStillMissing: 'still without coordinates',
        coordsPlaceholders: 'placeholder stops',
        coordsReferencePlatform: 'reference stops on the platform',
        coordsReferenceFiles: 'reference stops from files',
        coordsNoReference: 'No reference stops found for the Chieti area: upload a stops file with coordinates (CSV or GTFS zip) and try again.',
        coordsNothingToDo: 'Every stop already has real coordinates.',
        coordsDone: 'Stop coordinates updated',
        coordsFailed: 'Could not assign coordinates',
        tryAgain: 'Try again',
        geocodeRest: 'Find the remaining stops automatically',
        geocodeRestHint: 'The stop name is looked up within the Chieti area (the landmark in brackets, else the street) and snapped to the nearest road through the map server. About one stop per second: the dialog keeps going by itself until done.',
        coordsGeocoded: 'found from the name',
        coordsGeocodeCached: 'already known (no new lookups)',
        coordsGeocodeMissing: 'The remaining stops could not be found by name either. Press Try again to look them up once more (with a stops file too, if you have one): the others are already saved.',
        coordsRetryNote: 'stops still without coordinates: they will be looked up again, including the ones already tried. If you have a stops file with coordinates, add it above before starting.',
        detectLines: 'Detect lines',
        detectLinesIntro: 'For every attached vehicle, the GPS trajectory of the last days is compared with the stops of every line: the line whose stops the vehicle touched most is the candidate. Check the proposal, correct it where needed and confirm. A line assigned here stays "unconfirmed" until live matching confirms it.',
        runDetection: 'Run detection',
        detectionRunning: 'Analysing GPS history…',
        detectedLine: 'Detected line',
        coverage: 'Coverage',
        runnerUp: 'Runner-up',
        assignLine: 'Assign line',
        assignSelected: 'Assign selected',
        keepCurrent: 'Current',
        noChange: 'No change',
        clearLine: 'No line',
        historyDays: 'days of history',
        stopsCovered: 'stops touched',
        detectReason: {
          no_router: 'no GPS router attached',
          no_history: 'no GPS positions in the last days',
          no_stops: 'the line has no stops with coordinates',
          ambiguous: 'coverage too low or ambiguous between lines',
          detection_error: 'detection failed',
        },
        linesAssigned: 'Lines assigned',
        assignFailed: 'Could not assign the lines',
        nothingSelected: 'Select at least one vehicle',
        geocodeProgress: 'Looking up, stops remaining:',
        backToGtfs: 'Back to GTFS',
        stopsOfLine: 'Line stops',
        deleteGtfs: 'Delete GTFS',
        replaceGtfs: 'Replace GTFS',
        versions: 'Versions',
        previousVersion: 'Previous version',
        currentVersion: 'Current version',
        replacedOn: 'Replaced on',
        activeSince: 'Active since',
        areYouSureYouWantToDltThisGtfs: 'Are you sure you want to delete this GTFS?',
        route: 'Route',
        trip: 'Trip',
        lastSeen: 'Last Seen',
        fleetStatus: 'Fleet Status',
        activeVehicles: 'Active Vehicles',
        onlineDevices: 'Online Devices',
        gtfsFeeds: 'GTFS Feeds',
        online: 'Online',
        offline: 'Offline',
        inactive: 'Inactive',
        vehiclesPerLine: 'Vehicles per Line',
        welcomeBack: 'Welcome back',
        liveFleetMap: 'Live Fleet Map',
        live: 'Live',
        viewAll: 'View all',
        thisMonth: 'this month',
        goodMorning: 'Good morning',
        goodAfternoon: 'Good afternoon',
        goodEvening: 'Good evening',
        onlineOnly: 'Online only',
        total: 'Total',
        devices: 'Devices',
        users: 'Users',
        camera: 'Cameras',
        statics: 'Statistics',
        active: 'Active',
        vehicleName: 'Vehicle Name',
        deviceName: 'Device Name',
        progress: 'Progress',
        details: 'Details',
        licensePlate: 'License plate',
        companyAffiliation: 'Affiliation',
        totalDevices: 'Devices',
        vehicleCategory: 'Category',
        vehicleModel: 'Model',
        yearOfManufacture: 'Manufacture Year',
        operationStartDate: 'Start Date',
        action: 'Action',
        addVehicle: 'Add Vehicle',
        getReports: 'Get Reports',
        noVehiclesFound: 'No vehicles found',
        addVehicleToSee: 'Add a vehicle to see it listed here',
        vehiclesList: 'Vehicles List',
        techMaintenanceNotes: 'Technical or Maintenance Notes',
        vehicleDetails: 'Vehicle Details',
        editVehicle: 'Edit Vehicle',
        updateVehicle: 'Update Vehicle',
        notProvided: 'Not Provided',
        areYouSure: 'Are you sure?',
        delete: 'Delete',
        internalIdCode: 'Internal ID Code',
        enterInternalIdCode: 'Please enter the internal ID code',
        deviceType: 'Device Type',
        brand: 'Brand',
        model: 'Model',
        serialNumber: 'Serial Number',
        macAddress: 'MAC Address',
        enterMacAddress: 'Enter MAC Address',
        routerPassword: 'Router Password',
        routerName: 'Router Name',
        association: 'Association',
        vehicleAssociation: 'Vehicle Association',
        pleaseSelectVehicle: 'Please select the vehicle to associate',
        installationDate: 'Installation Date',
        addDevice: 'Add Device',
        deleteDeviceError: 'Unable to delete device. Please try again.',
        addDeviceError: 'Unable to add device. Please try again.',
        updateDevice: 'Update Device',
        deviceDetails: 'Device Details',
        areYouSureDeleteDevice: 'Are you sure you want to delete this device?',
        noDevicesFound: 'No devices found',
        addDeviceToSeeListed: 'Add a device to see it listed here',
        uniqueIdentificationCode: 'Unique Identification Code',
        pleaseEnterUniqueIdentificationCode: 'Please enter the unique identification code',
        pleaseEnterTypeOfDevice: 'Please enter the type of device',
        companyOrPersonName: 'Company or Person Name',
        pleaseEnterBrand: 'Please enter the brand',
        pleaseEnterModel: 'Please enter the model',
        pleaseEnterVehicleAssociation: 'Please enter vehicle association',
        pleaseSelectInstallationDate: 'Please select installation date',
        pleaseEnterRouter: 'Please enter the router name',
        pleaseEnterRouterPassword: 'Please enter the router password',
        pleaseEnterMacAddress: 'Please enter the MAC address',
        pleaseEnterSerialNumber: 'Please enter the serial number',
        typeOfDevice: 'Device Types',
        immediateAssociationToVehicle: 'Immediate Association to Vehicle',
        updateDevice: 'Update Device',
        editDevice: 'Edit Device',
        dateRange: 'Date Range',
        placeholder: {
            uniqueIdentificationCode: 'Enter unique identification code',
            typeOfDevice: 'Select Device Type',
            model: 'Enter model',
            brand: 'Enter brand',
            companyOrPersonName: 'Enter company or person name',
            immediateAssociationToVehicle: 'Enter vehicle association',
            installationDate: 'Select installation date',
            routerName: 'Enter router name',
            routerPassword: 'Enter router password',
            macAddress: 'Enter MAC address',
            serialNumber: 'Enter serial number'
        },
        profileInformation: 'Profile Information',
        company: 'Company',
        userName: 'User Name',
        email: 'Email Address',
        phone: 'Phone #',
        address: 'Address',
        addressLabel: 'Address',
        city: 'City',
        postalCode: 'Postal Code',
        country: 'Country',
        usersHeading: 'Users',
        settings: 'Settings',
        changePassword: 'Change Password',
        newPassword: 'New Password',
        confirmNewPassword: 'Confirm New Password',
        passwordMismatch: 'Passwords do not match!',
        profile: 'Profile',
        security: 'Security',
        needHelp: 'Need help?',
        checkOurDocs: 'Please check our docs',
        reports: 'Reports',
        map: 'Map',
        pleaseEnterYourNewpassword: 'Please enter your new password!',
        passwordMustBeatleat: 'Password must be at least 8 characters!',
        confirlnewpassword: 'Confirm New Password',
        changePasswrdButton: 'Change Password',
        pleaseConfirmNewpassword: 'Please confirm your new password!',
        passwordDonotMatch: 'Passwords do not match!',
        newpassword: 'New Password',
        profilerSetting: 'Profile',
        securityfleSetting: 'Security',
        settingHeading: 'Settings',
        uploadVehicleHint: 'Upload an Excel sheet (.xlsx or .xls) with one vehicle per row. Start date and manufacture year apply to every row.',
        dropExcelHere: 'Drag and drop the Excel file here, or click to browse',
        excelOnly: 'Only .xlsx or .xls files',
        replaceExcelHint: 'File selected. Drop or click to replace it',
        removeFile: 'Remove',
        parkingSessions: 'Parking sessions',
        showingRange: 'Showing {from}-{to} of {total}',
        viewDetails: 'View details',
        routerOnline: 'Router online',
        routerOffline: 'Router offline',
        updatedLabel: 'Updated',
        peopleCounterSubtitle: 'Entries and exits recorded by the passenger counters, per day and device.',
        peopleCounterRecordsTitle: 'Counter records',
        reportsSubtitle: 'Passenger counts per vehicle and day for the selected period.',
        filtersLabel: 'Filters',
        passengerReportsTitle: 'Passenger reports',
        noReportData: 'No data for these filters',
        noReportDataHint: 'Adjust the date range or the selected vehicles and apply again.',
        profileSettings: 'Profile Settings',
        profileSubtitle: 'Manage your personal information, password and preferences.',
        preferences: 'Preferences',
        personalInformation: 'Personal information',
        personalInformationHint: 'This is how your name and contact details appear across the platform.',
        fullName: 'Full name',
        emailAddress: 'Email address',
        emailLocked: 'Email is used to sign in and cannot be changed here.',
        phoneNumber: 'Phone number',
        organizationLabel: 'Organization',
        roleLabel: 'Role',
        memberSince: 'Member since',
        profilePhoto: 'Profile photo',
        uploadPhoto: 'Upload photo',
        removePhoto: 'Remove',
        photoHint: 'JPG, PNG or WebP, up to 2 MB.',
        saveChanges: 'Save changes',
        profileUpdated: 'Profile updated successfully',
        profileUpdateFailed: 'The request could not be completed. Please try again.',
        invalidImage: 'Please choose a JPG, PNG or WebP image under 2 MB',
        pleaseEnterName: 'Please enter your name',
        invalidPhone: 'Enter a valid phone number',
        changePassword: 'Change password',
        changePasswordHint: 'Use at least 8 characters, mixing letters, numbers and symbols.',
        currentPassword: 'Current password',
        pleaseEnterCurrentPassword: 'Please enter your current password',
        passwordStrength: 'Strength',
        weak: 'Weak',
        fair: 'Fair',
        good: 'Good',
        strong: 'Strong',
        passwordUpdated: 'Password changed successfully',
        languagePreference: 'Language',
        languageHint: 'Choose the language for menus, labels and dates.',
        english: 'English',
        italian: 'Italian',
        accountLabel: 'Account',
        userIdLabel: 'User ID',
        viewProfile: 'View profile',
        reportsHeading: 'Reports',
        filterheading: 'Filter',
        startDate: 'Start Date',
        endDate: 'End Date',
        vechiclelabel: 'Vehicle',
        linesLabel: 'Lines',
        clearText: 'Clear',
        applyTxt: 'Apply',
        datetxt: 'Time',
        activeVechicleL: 'Active Vehicles',
        fueltxt: 'Fuel',
        devicesTabletxt: 'Devices',
        profitloss: 'Profit/Loss',
        installDate: 'Installation Date',
        getReport: 'Get Report',
        generateTxt: 'Generate',
        generateReport: 'Generate Report',
        uniqueIdentificationTxt: 'Unique Identification Code',
        typeOfDevice: 'Device Type',
        downloadButton: 'Download',
        userNotFound: 'User Not Found',
        adduserToSeeItsList: 'Add a user to see it listed here',
        noDeviceFound: 'No Device Found',
        addOrganization: "Add Organization",
        ledScreenHeading: "Led",
        panelList: "Panel List",
        backColor: 'Back Color',
        textColor: 'Text Color',
        mode: "Mode",
        font: "Font",
        margin: "Margin",

        updatePenal: "Update Panel",
        addPenal: "Add Panel",



        organization: "Organization",
        device: "Device",
        direction: "Direction",
        line: "Line",
        front: "Front",
        rear: "Rear",
        side: "Side",
        deleteThisRecord: "Delete This Record",
        cancel: "Cancel",
        view: "View",
        panelRole: "Panel Role",
        panelModel: "Panel Model",
        text: "Text",
        effect: "Effect",
        speed: "Speed",
        brightness: "Brightness",
        busLedDeletedSuccessfully: "Bus LED Deleted Successfully",
        addBusLed: "Add Bus LED",
        totalRecord: "Total Record",
        preview: "Preview",
        pleaseSelectAnOrganization: "Please select an Organization",
        selectOrganizationHere: "Select Organization Here",
        selectDeviceHere: "Select Device Here",
        selectDeviceHere: "Select Device Here",
        panelUpdatedSuccessfully: "Panel Updated Successfully",
        panelAddedSuccessfully: "Panel Added Successfully",
        pleaseSelectAnOrganization: "Please select an Organization",
        pleaseSelectADevice: "Please select a Device",

        ledPanelUpdatedSuccessfully: "LED Panel Updated Successfully",
        selectOrginisation: "Select Orginisation",
        line: "Line",
        pleaseAddLine: "Please Add Line",
        direction: "Directions",
        pleaseAddDirection: "Please Add Direction",
        parking: "Parking",
        cameraMappings: "Camera Mappings",
        cameraMappingList: "Camera Mapping List",
        cameraName: "Camera Name",
        enterNotes: "Enter Notes",
        cameraId: "Camera Id",
        deviceId: "Device id",
        channelNo: "Channel no",
        gateId: "Gate id",
        gateType: "Gate Type",
        laneName: "Lane",

        enterDeviceId: "Enter Device Id",
        deviceIdRequired: "Device Id is required",
        enterCameraId: "Enter Camera Id",
        cameraIdRequired: "Camera Id is required",
        enterChannelNo: "Enter Channel No",
        channelNoRequired: "Channel No is required",

        enterGateId: "Enter Gate Id",
        gateIdRequired: "Gate Id is required",

        entry: "Entry",
        exit: "Exit",

        enterDescription: "Enter Description",

        enterLane: "Enter Lane",
        addCameraMapping: "Add Camera Mapping",
        editCameraMapping: "Edit Camera Mapping",
        cameraMappingAdded: "Camera Mapping added successfully",
        cameraMappingUpdated: "Camera Mapping updated successfully",
        cameraMappingDeleted: "Camera Mapping deleted successfully",
        deleteCameraMapping: "Camera Mapping deleted successfully",
        edit: "Edit",
        enterCameraName: "Enter Camera Name",
        directionRequired: "Please enter direction",
        enterDirection: "Enter Direction (entry, exit, parking)",
        enterLocation: "Enter Location",
        adding: "Adding...",
        updating: "Updating...",
        downloadError: "Failed to download",
        sessionExpired: "Session expired. Please log in again.",
        fetchCameraMappingError: "Failed to fetch camera mapping data.",
        errorFetchingCameraMappings: "Error fetching Camera Mappings.",
        failedToAddCameraMapping: "Failed to add Camera Mapping.",
        errorAddingCameraMapping: "Error adding Camera Mapping.",
        failedToUpdateCameraMapping: "Failed to update Camera Mapping.",
        errorUpdatingCameraMapping: "Error updating Camera Mapping.",
        failedToDeleteCameraMapping: "Failed to delete camera mapping.",
        errorDeletingCameraMapping: "Error deleting camera mapping.",
        qrCodeNotAvailable: "QR code not available",
        pdfNotAvailable: "PDF not available",
        isActive: "Is Active",
        all: "All",
        inactive: "Inactive",

        // Override / new keys for previously hardcoded UI strings
        routes: 'Routes',
        datetxt: 'Time',
        online: 'Online',
        offline: 'Offline',

        count: 'count',
        noData: 'No data',
        noDataAvailable: 'No Data Available',
        noVehicleDataAvailable: 'No vehicle data available',
        loadingDeviceLocation: 'Loading device location...',
        pleaseEnterIpAddress: 'Please enter IP address',
        invalidIPv4: 'Invalid IPv4 format (e.g. 192.168.0.1)',
        refreshValidatorsMessage: 'The validators list is being refreshed and may take a while.',
        refreshValidatorsSuccess: 'Validators List Refresh successfully',
        refreshValidatorsFailed: 'Failed to Refresh validators',
        pleaseCompleteFormRequirements: 'Please complete the form requirements',
        pleaseFillOutRequiredFields: 'Please fill out {{roles}} required fields',
        pleaseFillOutFrontSideRearRequiredFields: 'Please fill out Front, Side and Rear required fields',
        viewFront: 'View Front',
        viewSide: 'View Side',
        viewRear: 'View Rear',
        selectEntryTime: 'Select entry time',
        selectPaymentTime: 'Select payment time',
        selectExitTime: 'Select exit time',
        errorUpdatingParkingSession: 'Error updating parking session.',
        actions: 'Actions',
        plateRequired: 'Please enter plate number',
        pleaseEnterParkingLotName: 'Please enter parking lot name',
        pleaseEnterAddress: 'Please enter address',
        pleaseEnterTotalSpaces: 'Please enter total number of spaces',
        pleaseEnterValidNumber: 'Please enter a valid number 222',
        totalSpacesAtLeast1: 'Total spaces must be at least 1',
        totalSpacesMax: 'Total spaces cannot exceed 100000',
        totalSpacesWholeNumber: 'Total spaces must be a whole number',
        pleaseSelectOrganization: 'Please select an organization',
        fileRequired: 'Files is required',
        noDataFound: 'No data Found',
        uploadExcelFile: 'Upload Excel File',
        teltonikaInstructionsGuide: 'Teltonika instructions guide',
        and: 'and',
        requiredFields: 'required fields',
        routerType: 'Router Type',
        selectRouterType: 'Select Router Type',
        downloadPDF: 'Download PDF',
    }
}

const imageTypes = `image/png, image/jpeg, image/jpg, image/webp`

const pageSizeOptions = ['10', '20', '50', '100']

const vehicleRouteColors = [
    '#FF5733', // Red-orange
    '#33A1FD', // Sky blue
    '#28A745', // Green
    '#FFC107', // Amber
    '#6F42C1', // Purple
    '#E83E8C', // Pink
    '#20C997', // Teal
    '#FD7E14', // Orange
    '#17A2B8', // Cyan
    '#6610F2', // Indigo
    '#DC3545', // Red
    '#007BFF', // Blue
    '#F39C12', // Yellow-orange
    '#8E44AD', // Deep purple
    '#1ABC9C', // Turquoise
    '#2ECC71', // Emerald green
    '#3498DB', // Strong blue
    '#E74C3C', // Strong red
    '#9B59B6', // Light purple
    '#34495E',  // Dark slate
    '#4285F4'
]


export {
    bgColor,
    // drawerRoutes,
    allPaths,
    version,
    deployDate,
    containerStyle,
    center,
    dateFormate,
    // googleClientId,
    translations,
    imageTypes,
    pageSizeOptions,
    tableDateFormate,
    vehicleRouteColors
}
